import type { ContentItem } from '../contentLibrary'

export const MODERN_ARTICLES: ContentItem[] = [
  {
    id: 'poem-zaibiechuangqiao',
    category: 'poem',
    dynasty: 'modern',
    title: '再別康橋',
    source: '徐志摩',
    description: '徐志摩最著名的抒情現代詩，節奏輕快而感情繾綣。',
    content: '輕輕的我走了，正如我輕輕的來；我輕輕的招手，作別西天的雲彩。那河畔的金柳，是夕陽中的新娘；波光裡的豔影，在我的心頭蕩漾。軟泥上的青荇，油油的在水底招搖；在康河的柔波裡，我甘心做一條水草！那榆蔭下的一潭，不是清泉，是天上虹；揉碎在浮藻間，沉澱著彩虹似的夢。尋夢？撐一支長篙，向青草更青處漫溯；滿載一船星輝，在星輝斑斕裡放歌。但我不能放歌，悄悄是別離的笙簫；夏蟲也為我沉默，沉默是今晚的康橋！悄悄的我走了，正如我悄悄的來；我揮一揮衣袖，不帶走一片雲彩。',
  },

  {
    id: 'poem-cuowu',
    category: 'poem',
    dynasty: 'modern',
    title: '錯誤',
    source: '鄭愁予',
    description: '現代詩的經典名篇，極具中國傳統古典閨怨詩詞之美。',
    content: '我打江南走過，那等在季節裡的容顏如蓮花的開落。東風不來，三月的柳絮不飛，你的心如小小的寂寞的城，恰若青石的街道向晚。跫音不響，三月的春帷不揭，你的心是小小的窗扉緊掩。我達達的馬蹄是美麗的錯誤，我不是歸人，是個過客……',
  },

  {
    id: 'poem-xiangchou',
    category: 'poem',
    dynasty: 'modern',
    title: '鄉愁',
    source: '余光中',
    description: '余光中膾炙人口之作，結構對稱，意象豐富，深情款款。',
    content: '小時候，鄉愁是一枚小小的郵票，我在這頭，母親在這頭。長大後，鄉愁是一張窄窄的船票，我在這頭，新娘在那頭。後來啊，鄉愁是一方矮矮的墳墓，我在外頭，母親在裡頭。而現在，鄉愁是一灣淺淺的海峽，我在這頭，大陸在那頭。',
  },

  {
    id: 'poem-yangmujieqiao',
    category: 'poem',
    dynasty: 'modern',
    title: '介殼蟲',
    source: '楊牧',
    description: '楊牧詩風溫婉典雅，富含哲理與古典音樂般的節奏感。',
    content: '如果我的離去是一小朵雲的消散，如果我是一抹，微不足道的，冷卻了的火焰，你是否願意，在落葉如雨的季節，為我保留，一片枯萎的葉子？如果我是你，在黑暗中微弱的呼吸，你是否願意，為我點亮，那一盞，微小的，即將熄滅的燈？',
  },

  {
    id: 'poem-yangmugudu',
    category: 'poem',
    dynasty: 'modern',
    title: '孤獨',
    source: '楊牧',
    description: '楊牧極具代表性的抒情佳作，將孤獨意象化為一匹老獸。',
    content: '孤獨是一匹衰老的獸，潛伏在我亂石嶙峋的心中。當夕陽，在海的盡頭，燃燒起，最後一抹，淒涼的血紅，牠便會慢慢睜開，冷酷的雙眼，用牠那長長的、冰冷的舌頭，默默舔舐著，我靈魂深處，那一道，永遠無法癒合的，傷口。',
  },

  {
    id: 'poem-ouran',
    category: 'poem',
    dynasty: 'modern',
    title: '偶然',
    source: '徐志摩',
    description: '徐志摩極具哲思的抒情短詩，寫人生的偶然與交會。',
    content: '我是天空裡的一片雲，偶爾投影在你的波心。你不必訝異，更無須歡喜，在轉瞬間消滅了蹤影。你我相逢在黑夜的海上，你有你的，我有我的，方向；你記得也好，最好你忘掉，在這交會時互放的光亮。',
  },

  {
    id: 'poem-xuehuauai',
    category: 'poem',
    dynasty: 'modern',
    title: '雪花的快樂',
    source: '徐志摩',
    description: '徐志摩以雪花自喻，追尋理想中的愛情。',
    content: '假如我是一朵雪花，翩翩的在半空裡瀟灑，我一定認清我的方向——飛颺，飛颺，飛颺，這地面上有我的方向。不去那冷寞的幽谷，不去那悽清的山麓，也不上荒街去惆悵——飛颺，飛颺，飛颺，你看，我有我的方向。在半空裡娟娟的飛舞，認明了那清幽的住處，等著她來花園裡探望——飛颺，飛颺，飛颺，啊，她身上有硃砂梅的清香！',
  },

  {
    id: 'poem-shayangnala',
    category: 'poem',
    dynasty: 'modern',
    title: '沙揚娜拉',
    source: '徐志摩',
    description: '徐志摩贈日本女郎的送別詩，溫柔繾綣。',
    content: '最是那一低頭的溫柔，像一朵水蓮花不勝涼風的嬌羞，道一聲珍重，道一聲珍重，那一聲珍重裡有蜜甜的憂愁——沙揚娜拉！',
  },

  {
    id: 'poem-yangmuzao',
    category: 'poem',
    dynasty: 'modern',
    title: '早春',
    source: '楊牧',
    description: '楊牧以早春意象寫生命的覺醒與沉思。',
    content: '當那朝陽的第一道光芒，照射在覆雪的山巔之上，我便知道，春天已經不遠了。冰封的溪水開始低語，沈睡的種子也在泥土中翻身，而我，站在歲月的渡口，靜靜等待，那一場屬於生命的，溫柔的覺醒。',
  },

  {
    id: 'poem-yangmuxue',
    category: 'poem',
    dynasty: 'modern',
    title: '雪止',
    source: '楊牧',
    description: '楊牧詩中常見的雪意象，寂靜而深邃。',
    content: '雪止了，天地之間只剩下一片純淨的白。我獨自行走在無人的曠野，腳下是綿綿的積雪，耳邊是風的嘆息。回首來時路，足跡已被新雪覆蓋，彷彿從未有人走過。前路漫漫，看不到盡頭，但我依然要走下去，走向那更深的，更寂靜的，白。',
  },

  {
    id: 'poem-yangmuqiufeng',
    category: 'poem',
    dynasty: 'modern',
    title: '秋風',
    source: '楊牧',
    description: '楊牧以秋風寫歲月的流逝與生命的感悟。',
    content: '秋風起了，落葉在風中旋舞。我站在窗前，看它們一片一片，飄落，堆積，然後又被風吹散。這讓我想起，那些曾經擁有的，失去的，遺忘的，都像這些落葉一樣，終將歸於塵土。但我知道，來年春天，新葉又會在枝頭萌發，就像生命，總是在死亡中，找到新的開始。',
  },

  {
    id: 'poem-yangmuyu',
    category: 'poem',
    dynasty: 'modern',
    title: '雨夜',
    source: '楊牧',
    description: '楊牧在雨夜中追憶逝去的時光，情感內斂深沉。',
    content: '雨，不停地下著，在這樣一個寂靜的夜。我獨坐窗前，聽雨聲穿過黑暗，敲打著屋簷，敲打著我的心。遠處的燈火，在雨幕中搖曳，迷離而遙遠，就像那些逝去的日子，再也觸摸不到。但我依然記得，那些溫暖的瞬間，那些曾經讓我感動的，微笑的，流淚的，一切的一切。',
  },

  {
    id: 'poem-yangmu-shuizhimei',
    category: 'poem',
    dynasty: 'modern',
    title: '水之湄',
    source: '楊牧',
    description: '楊牧（葉珊時期）傳誦極廣的唯美抒情浪漫代表作。',
    content: '水之湄，有女清揚，有女如玉。我在青青的草地上走過，聽溪水淙淙地歌唱。那遠方的白雲，可是你飄動的衣裳？那林間的微風，可是你溫柔的低語？',
  },

  {
    id: 'poem-yangmu-yanlingjizi',
    category: 'poem',
    dynasty: 'modern',
    title: '延陵季子掛劍',
    source: '楊牧',
    description: '楊牧融會古典典故與現代抒情之美的史詩級名篇。',
    content: '季子，這就是那把千金之劍。徐君雖已逝去，然吾心早已許之，豈可以死而背吾心？解下腰間寶劍，輕輕懸於塚樹之上，微風吹過，劍光如秋水，照亮千古不滅的情誼。',
  },

  {
    id: 'poem-yangmu-gongliyuzhengyi',
    category: 'poem',
    dynasty: 'modern',
    title: '有人問我公理和正義的問題',
    source: '楊牧',
    description: '楊牧享譽華人文壇的深刻哲理與社會關懷長詩精選。',
    content: '有人問我公理和正義的問題。我看見陽光照在古老的石階上，我看見種子在黑暗的泥土裡默默生長。公理不是喧囂的口號，而是清晨那一滴乾淨的露水；正義不是鋒利的刀刃，而是守護生命時無聲的堅定。',
  },

  {
    id: 'poem-yangmu-dainihuihualian',
    category: 'poem',
    dynasty: 'modern',
    title: '帶你回花蓮',
    source: '楊牧',
    description: '楊牧獻給故鄉花蓮山海的深情之作。',
    content: '帶你回花蓮，去看那片浩瀚無際的太平洋。海浪拍打著黑色的礫石灘，在陽光下泛著銀白色的泡沫。山巒在雲霧中若隱若現，那是我們靈魂最安詳的歸宿。',
  },

  {
    id: 'poem-yangmu-yeying',
    category: 'poem',
    dynasty: 'modern',
    title: '野櫻',
    source: '楊牧',
    description: '楊牧描繪初春山林花開與時光靜好的純淨短詩。',
    content: '野櫻在初春的山谷裡靜靜開了，粉白的花瓣落了一地。微風穿過林間，帶來泥土與花香的氣息。此時天地俱寂，只聽得見花開與花落的聲音。',
  },

  {
    id: 'poem-yangmu-linchong',
    category: 'poem',
    dynasty: 'modern',
    title: '林沖夜奔',
    source: '楊牧',
    description: '楊牧融匯古典戲曲與現代心理刻畫的名作。',
    content: '風雪滿天，英雄在黑夜的長道上奔馳。回頭是萬家燈火的禁錮，向前是浩瀚無邊的天地。拔劍向天，那一聲長嘯，劃破了千年的寂寞與嚴寒。',
  },

  {
    id: 'poem-modern-hope',
    category: 'poem',
    dynasty: 'modern',
    title: '希望',
    source: '胡適',
    description: '胡適白話詩名篇，後譜曲為〈蘭花草〉傳唱至今。',
    content: '我從山中來，帶著蘭花草。種在小園中，希望花開早。一日望三回，望到花時過。急壞看花人，苞也無一個。眼見秋天到，移花供在家。明年春風回，祝汝滿盆花。',
  },

  {
    id: 'poem-modern-mengshi',
    category: 'poem',
    dynasty: 'modern',
    title: '夢與詩',
    source: '胡適',
    description: '胡適論夢與真實的關係，富於哲理。',
    content: '都是平常經驗，都是平常影象，偶然湧到夢中來，變幻出多少新奇花樣！都是平常情感，都是平常言語，偶然碰著個詩人，變幻出多少新奇詩句！醉過才知酒濃，愛過才知情重。你不能做我的詩，正如我不能做你的夢。',
  },

  {
    id: 'poem-modern-yige',
    category: 'poem',
    dynasty: 'modern',
    title: '一棵開花的樹',
    source: '席慕蓉',
    description: '席慕蓉代表作，以樹喻人，寫對愛情最虔誠的等待。',
    content: '如何讓你遇見我，在我最美麗的時刻。為這，我已在佛前求了五百年，求佛讓我們結一段塵緣。佛於是把我化做一棵樹，長在你必經的路旁。陽光下慎重地開滿了花，朵朵都是我前世的盼望。當你走近，請你細聽，那顫抖的葉是我等待的熱情。而當你終於無視地走過，在你身後落了一地的，朋友啊，那不是花瓣，是我凋零的心。',
  },

  {
    id: 'poem-modern-youth',
    category: 'poem',
    dynasty: 'modern',
    title: '青春',
    source: '席慕蓉',
    description: '席慕蓉現代詩《青春》全文，寫青春易逝與年華不可追回。',
    content: '所有的結局都已寫好，所有的淚水也都已啟程，卻忽然忘了是怎麼樣的一個開始，在那個古老的不再回來的夏日。無論我如何地去追索，年輕的你只如雲影掠過。而你微笑的面容極淺極淡，逐漸隱沒在日落後的群嵐。遂翻開那發黃的扉頁，命運將它裝訂得極為拙劣。含著淚，我一讀再讀，卻不得不承認，青春是一本太倉促的書。',
  },

  {
    id: 'poem-modern-qilixiang',
    category: 'poem',
    dynasty: 'modern',
    title: '七里香',
    source: '席慕蓉',
    description: '席慕蓉以七里香寄託青春的記憶與情感。',
    content: '溪水急著要流向海洋，浪潮卻渴望重回土地。在綠樹白花的籬前，曾那樣輕易地揮手道別。而滄桑的二十年後，我們的魂魄卻夜夜歸來。微風拂過時，便化作滿園的鬱香。',
  },

  {
    id: 'poem-modern-lian',
    category: 'poem',
    dynasty: 'modern',
    title: '蓮的心事',
    source: '席慕蓉',
    description: '席慕蓉以蓮喻懷春少女，婉約細膩。',
    content: '我是一朵盛開的夏荷，多希望你能看見現在的我。風霜還不曾來侵蝕，秋雨還未曾滴落，青澀的季節又已離我遠去。我已亭亭，不憂，亦不懼。現在正是最美麗的時刻，重門卻已深鎖。在芬芳的笑靨之後，誰知我蓮的心事？無緣的你啊，不是來得太早，就是太遲。',
  },

  {
    id: 'poem-modern-wuyuan',
    category: 'poem',
    dynasty: 'modern',
    title: '無怨的青春',
    source: '席慕蓉',
    description: '席慕蓉談愛情的無怨無悔，溫柔而堅定。',
    content: '在年輕的時候，如果你愛上了一個人，請你一定要溫柔地對待他。不管你們相愛的時間有多長或多短，若你們能始終溫柔地相待，那麼所有的時刻都將是一種無瑕的美麗。若不得不分離，也要好好地說一聲再見，也要在心裡存著感謝，感謝他給了你一份記憶。長大了以後，你才會知道，在驀然回首的剎那，沒有怨恨的青春才會了無遺憾，如山岡上那輪靜靜的滿月。',
  },

  {
    id: 'poem-modern-aren',
    category: 'poem',
    dynasty: 'modern',
    title: '你是人間的四月天',
    source: '林徽因',
    description: '林徽因最經典的詩作，以四月天喻生命的美好與愛。',
    content: '我說你是人間的四月天；笑響點亮了四面風；輕靈在春的光豔中交舞著變。你是四月早天裡的雲煙，黃昏吹著風的軟，星子在無意中閃，細雨點灑在花前。那輕，那娉婷，你是，鮮妍百花的冠冕你戴著，你是天真，莊嚴，你是夜夜的月圓。雪化後那片鵝黃，你像；新鮮初放芽的綠，你是；柔嫩喜悅，水光浮動著你夢期待中白蓮。你是一樹一樹的花開，是燕在梁間呢喃，——你是愛，是暖，是希望，你是人間的四月天！',
  },

  {
    id: 'poem-modern-biediudiao',
    category: 'poem',
    dynasty: 'modern',
    title: '別丟掉',
    source: '林徽因',
    description: '林徽因懷念徐志摩之作，深情含蓄。',
    content: '別丟掉，這一把過往的熱情。現在流水似的，輕輕，在幽冷的山泉底，在黑夜，在松林，嘆息似的渺茫，你仍要保存著那真。一樣是月明，一樣是隔山燈火，滿天的星，只有人不見，夢似的掛起，你向黑夜要回那一句話——你仍得相信，山谷中留著，那迴音。',
  },

  {
    id: 'poem-modern-qiyuan',
    category: 'poem',
    dynasty: 'modern',
    title: '七子之歌·澳門',
    source: '聞一多',
    description: '聞一多以七子自喻，抒發澳門被殖民之痛與回歸之盼。',
    content: '你可知「媽港」不是我的真名姓？我離開你的襁褓太久了，母親！但是他們擄去的是我的肉體，你依然保管我內心的靈魂。三百年來夢寐不忘的生母啊！請叫兒的乳名，叫我一聲「澳門」！母親！我要回來，母親！',
  },

  {
    id: 'poem-modern-7zi2',
    category: 'poem',
    dynasty: 'modern',
    title: '七子之歌·香港',
    source: '聞一多',
    description: '聞一多以香港為子，抒寫遊子思歸之情。',
    content: '我好比鳳闕階前守夜的黃豹，母親呀，我身份雖微，地位險要。如今獰惡的海獅撲在我身上，啖著我的骨肉，嚥著我的脂膏。母親呀，我哭泣號咷，呼你不應。母親呀，快讓我躲入你的懷抱！母親！我要回來，母親！',
  },

  {
    id: 'poem-modern-sishui',
    category: 'poem',
    dynasty: 'modern',
    title: '死水',
    source: '聞一多',
    description: '聞一多以死水喻舊中國的腐朽與停滯，寄託改造的希望。',
    content: '這是一溝絕望的死水，清風吹不起半點漪淪。不如多扔些破銅爛鐵，爽性潑你的剩菜殘羹。也許銅的要綠成翡翠，鐵罐上銹出幾瓣桃花。再讓油膩織一層羅綺，黴菌給他蒸出些雲霞。讓死水酵成一溝綠酒，飄滿了珍珠似的白沫。小珠們笑聲變成大珠，又被偷酒的花蚊咬破。那麼一溝絕望的死水，也就跨得上幾分鮮明。如果青蛙耐不住寂寞，又算死水叫出了歌聲。這是一溝絕望的死水，這裡斷不是美的所在。不如讓給醜惡來開墾，看他造出個什麼世界。',
  },

  {
    id: 'poem-modern-rainy',
    category: 'poem',
    dynasty: 'modern',
    title: '雨巷',
    source: '戴望舒',
    description: '戴望舒象徵主義代表作，雨中丁香般的哀愁。',
    content: '撐著油紙傘，獨自彷徨在悠長，悠長，又寂寥的雨巷，我希望逢著一個丁香一樣地結著愁怨的姑娘。她是有丁香一樣的顏色，丁香一樣的芬芳，丁香一樣的憂愁，在雨中哀怨，哀怨又彷徨。她彷徨在這寂寥的雨巷，撐著油紙傘像我一樣，像我一樣地，默默彳亍著，冷漠，淒清，又惆悵。她靜默地走近，走近，又投出太息一般的眼光。她飄過，像夢一般地，像夢一般地淒婉迷茫。',
  },

  {
    id: 'poem-modern-duanzhang',
    category: 'poem',
    dynasty: 'modern',
    title: '斷章',
    source: '卞之琳',
    description: '卞之琳極簡主義名篇，你裝飾了別人的夢。',
    content: '你站在橋上看風景，看風景人在樓上看你。明月裝飾了你的窗子，你裝飾了別人的夢。',
  },

  {
    id: 'poem-modern-dengni',
    category: 'poem',
    dynasty: 'modern',
    title: '等你，在雨中',
    source: '余光中',
    description: '余光中情詩名篇，融合古典意象與現代情感。',
    content: '等你，在雨中，在造虹的雨中。蟬聲沉落，蛙聲升起，一池的紅蓮如紅焰，在雨中。你來不來都一樣，竟感覺每朵蓮都像你，尤其隔著黃昏，隔著這樣的細雨。永恆，剎那，剎那，永恆。等你，在時間之外，在時間之內，等你，在剎那，在永恆。如果你的手在我的手裡，此刻，如果你的清芬，在我的鼻孔，我會說，小情人，諾，這隻手應該採蓮，在吳宮，這隻手應該搖一柄桂槳，在木蘭舟中。',
  },

  {
    id: 'poem-modern-baiyu',
    category: 'poem',
    dynasty: 'modern',
    title: '白玉苦瓜',
    source: '余光中',
    description: '余光中以故宮白玉苦瓜為題，寄託文化傳承的深沉情感。',
    content: '似醒似睡，緩緩的柔光裡，似悠悠醒自千年的大寐。一隻瓜從從容容在成熟，一隻苦瓜，不再是澀苦。日磨月磋琢出深孕的清瑩，看莖鬚繚繞，葉掌撫抱，哪一年的豐收像一口要吸盡古中國餵了又餵的乳漿。不碰那滾滾的時間，那濤濤的沸湯，就讓我睡在母親的懷裡，讓母親懷抱中國。',
  },

  {
    id: 'poem-modern-dangwosi',
    category: 'poem',
    dynasty: 'modern',
    title: '當我死時',
    source: '余光中',
    description: '余光中寫對故土的眷戀，願死後魂歸大陸。',
    content: '當我死時，葬我，在長江與黃河之間，枕我的頭顱，白髮蓋著黑土。在中國，最美最母親的國度。我便坦然睡去，睡整張大陸。聽兩側，安魂曲起自長江，黃河，兩管永恆的音樂，滔滔，朝東。這是最縱容最寬闊的床，讓一顆心滿足地睡去，滿足地想。從前，一個中國的青年曾經，在冰凍的密西根向西瞭望，想望透黑夜看中國的黎明。用十七年未饜中國的眼睛，饕餮地地圖，從西湖到太湖，到多鷓鴣的重慶，代替回鄉。',
  },

  {
    id: 'poem-modern-xunlibai',
    category: 'poem',
    dynasty: 'modern',
    title: '尋李白',
    source: '余光中',
    description: '余光中向詩仙李白致敬，豪放縱逸。',
    content: '那一雙傲慢的靴子至今還落在高力士羞憤的手裡，我們卻特地要來尋你。酒入豪腸，七分釀成了月光，餘下的三分嘯成劍氣，繡口一吐就半個盛唐。從開元到天寶，從洛陽到咸陽，冠蓋滿途車騎的囂鬧，不及千年後你的一首，水晶絕句輕叩我額頭，噹的一聲挑起的迴音。',
  },

  {
    id: 'poem-modern-fubie',
    category: 'poem',
    dynasty: 'modern',
    title: '賦別',
    source: '鄭愁予',
    description: '鄭愁予以古典筆法寫現代離情，韻味悠長。',
    content: '這次我離開你，是風，是雨，是夜晚。你笑了笑，我擺一擺手，一條寂寞的路便展向兩頭了。念此際你已回到濱河的家居，想你在梳理長髮或整理濕了的外衣。而我風雨歸途，我的歸途，我的歸途是等你，等你，用我的心，用我的歌，用我的沉默。',
  },

  {
    id: 'poem-modern-guduguo',
    category: 'poem',
    dynasty: 'modern',
    title: '孤獨國',
    source: '周夢蝶',
    description: '周夢蝶禪意詩作，在孤獨中成就自足的王國。',
    content: '昨夜，我又夢見我，赤裸地趺坐在負雪的山峰上。這裡的氣候粘在冬天與春天的接口處，這裡的夜，鷲鷹與貓頭鷹的混血兒，悄悄地撲過來，不允許受驚的獵物哀叫。這裡的風，最大的敵人，以一根看不見的繩索，將我緊緊捆綁。而這裡的雪，像初生嬰兒的肌膚，溫潤而潔白，我是唯一醒著的人，在時間的廢墟上，建立我的王國。',
  },

  {
    id: 'poem-modern-yinwai',
    category: 'poem',
    dynasty: 'modern',
    title: '煙之外',
    source: '洛夫',
    description: '洛夫超現實主義詩風的經典之作。',
    content: '在濤聲中喚你的名字，而你的名字，已在千帆之外。潮來潮去，左邊的鞋印才下午，右邊的鞋印已黃昏了。六月，原是一本很感傷的書。結局如此之悽美，落日，一般。當我推門時，你已不在，濤聲中，煙之外，你的名字，在千帆之外。',
  },

  {
    id: 'poem-modern-fengde',
    category: 'poem',
    dynasty: 'modern',
    title: '因為風的緣故',
    source: '洛夫',
    description: '洛夫以風為信使，寫溫柔情書。',
    content: '昨日我沿著河岸，漫步到，蘆葦彎腰喝水的地方。順便請煙囪，在天空為我寫一封長長的信，潦是潦草了些，而我的心意，則明亮亦如你窗前的燭光。稍有曖昧之處，勢所難免，因為風的緣故。此信你能否看懂並不重要，重要的是，你務必在雛菊尚未全部凋謝之前，趕快發怒，或者發笑。趕快從箱子裡找出我那件薄衫，趕快將爐火生起，因為，風的緣故。',
  },

  {
    id: 'poem-modern-ruge',
    category: 'poem',
    dynasty: 'modern',
    title: '如歌的行板',
    source: '瘂弦',
    description: '瘂弦以生活瑣碎入詩，看似隨意實則深沉。',
    content: '溫柔之必要，肯定之必要，一點點酒和木樨花之必要。正正經經看一名女子走過之必要。君非海明威此一起碼認識之必要。歐戰，雨，加農砲，天氣與紅十字會之必要。散步之必要。溜狗之必要。薄荷茶之必要。每晚七點鐘自證券交易所彼端，草一般飄起來的謠言之必要。旋轉玻璃門之必要。盤尼西林之必要。暗殺之必要。晚報之必要。而黃昏、雖然不是每個人都有，但是，一陣風，和風中，一陣，一陣的，笛子的聲音，之必要。',
  },

  {
    id: 'poem-modern-mengtu',
    category: 'poem',
    dynasty: 'modern',
    title: '夢土上',
    source: '鄭愁予',
    description: '鄭愁予寫夢與遠方，飄逸如雲。',
    content: '雲在我的衣袋，我的衣袋裡有樹，有落下來的小雨，也有春天。而春天在我的衣袋裡很小，像一顆剛成熟的青梅。我從不把夢帶出夢土，夢土是軟軟的，像你攤開的手帕。當我醒來，雲在我的衣袋裡，軟軟的，像你攤開的手帕。',
  },

  {
    id: 'poem-modern-qiugei',
    category: 'poem',
    dynasty: 'modern',
    title: '秋歌·給暖暖',
    source: '瘂弦',
    description: '瘂弦以秋景入詩，在蕭瑟中尋找溫暖。',
    content: '落葉完成了最後的顫抖，荻花在湖沼的藍睛裡消失。七月的砧聲遠了，暖暖。雁子們也不在遼夐的秋空，寫牠們美麗的十四行了。暖暖。秋天，秋天什麼也沒留下，只留下一個暖暖。只留下一個暖暖，一切便都留下了。',
  },

  {
    id: 'poem-modern-yiqing',
    category: 'poem',
    dynasty: 'modern',
    title: '情願',
    source: '林徽因',
    description: '林徽因寫情願為愛付出一切的決心。',
    content: '情願我化成一片落葉，讓風吹雨打到處飄零；或流雲一朵，在澄藍天，和大地再沒有些牽連。但抱緊那傷心的標誌，去觸遇沒著落的悵惘；在黃昏，夜半，躡著腳走，全是空虛，再莫有溫柔。忘掉曾有這世界；有你；哀悼誰又曾有過愛戀；落花似的落盡了，忘了去這些個淚點裡的情緒。到那天一切都不存留，比一閃光，一息風更少，痕跡，你也要忘掉了我，曾經在這世界裡活過。',
  },

  {
    id: 'poem-modern-cha',
    category: 'poem',
    dynasty: 'modern',
    title: '剎那',
    source: '周夢蝶',
    description: '周夢蝶以禪意觀照剎那與永恆。',
    content: '當我經過你的窗前，菊花已開過許多日子。在薄霜的早晨，我看見你，像一株沉思的樹。你的沉默，是一支很美麗的歌，我無法唱出，只能靜靜地聽著，用心，用整個生命。當陽光斜斜地照進來，落在你微揚的髮梢，我才突然明白，有些花，是永遠不會凋謝的，就像有些歌，唱著唱著，就成了永恆。',
  },

  {
    id: 'poem-modern-nide',
    category: 'poem',
    dynasty: 'modern',
    title: '你的名字',
    source: '紀弦',
    description: '紀弦以重複疊句呼喚愛人的名字，深情執著。',
    content: '用了世界上最輕最輕的聲音，輕輕地喚你的名字每夜每夜。寫你的名字，畫你的名字，而夢見的是你的發光的名字。如日，如星，你的名字。如燈，如鑽石，你的名字。如繽紛的火花，如閃電，你的名字。如原始森林的燃燒，你的名字。刻你的名字，刻你的名字在樹上，刻你的名字在不凋的生命樹上。當這植物長成了參天的古木時，啊啊，多好，多好，你的名字也大起來。大起來了，你的名字。亮起來了，你的名字。於是，輕輕輕輕輕輕輕地喚你的名字。',
  },

  {
    id: 'poem-modern-dushu',
    category: 'poem',
    dynasty: 'modern',
    title: '獨語',
    source: '覃子豪',
    description: '覃子豪以海為背景，寫孤獨中的沉思與追問。',
    content: '我向海洋說：我懷念你，海洋應我以柔和的潮聲。我向森林說：我懷念你，森林回我以悅耳的鳥鳴。我向星空說：我懷念你，星空應我以靜夜的幽寂。我向我心說：我懷念你，心卻回我以無言的沉默。我向他說：我懷念你，他卻回答我：我早已忘記。',
  },

  {
    id: 'poem-modern-nawei',
    category: 'poem',
    dynasty: 'modern',
    title: '那一晚',
    source: '林徽因',
    description: '林徽因以夜晚為背景，追憶一段無法回頭的時光。',
    content: '那一晚我的船推出了河心，澄藍的天上托著密密的星。那一晚兩岸裡閃映著燈光，你眼裡含著淚，我心裡惶。那一晚天這樣黑，夜這樣靜，船在動，星在流，我在想。那一天你要聽到鳥般的歌唱，那便是我靜夜的回想。那一天你要看到零亂的花影，那便是我私闖入當年的邊境。',
  },

  {
    id: 'poem-modern-kuo',
    category: 'poem',
    dynasty: 'modern',
    title: '天問',
    source: '余光中',
    description: '余光中向星空發問，寫宇宙之浩瀚與生命之渺小。',
    content: '天問是詩人的特權。當夜色將我們籠罩，所有的星子都亮了起來，像是遠古的神話，在無邊的黑暗中閃爍。究竟哪一顆星才是我們的歸宿？或許我們都是一顆流浪的星，在無垠的宇宙中尋找自己的軌道。而答案，總是在更高的天上。',
  },

  {
    id: 'poem-modern-bianjie',
    category: 'poem',
    dynasty: 'modern',
    title: '邊界望鄉',
    source: '洛夫',
    description: '洛夫在香港落馬洲眺望大陸，寫鄉愁如刀。',
    content: '說著說著，我們就到了落馬洲。霧正升起，我們在茫然中勒馬四顧。手掌開始生汗，望遠鏡中擴大數十倍的鄉愁，亂如風中的散髮。當距離調整到令人心跳的程度，一座遠山迎面飛來，把我撞成了嚴重的內傷。病了病了，病得像山坡上那叢凋殘的杜鵑，只剩下唯一的一朵。蹲在那塊石碑上，聽著遠處的童聲，一首歌，唱著。',
  },

  {
    id: 'poem-modern-bedrock',
    category: 'poem',
    dynasty: 'modern',
    title: '殘堡',
    source: '鄭愁予',
    description: '鄭愁予以廢棄的堡壘寫歷史的蒼涼與時間的無情。',
    content: '戍守的人已歸了，留下邊城的殘堡。百年來，只有風，從山那邊吹來，帶著草香和沙礫。我的馬兒，在斜陽外，踢著石子。蹄聲響過，就再也沒有消息。只有風，還是不分季節地吹著。百年來，只有風。',
  },

  {
    id: 'poem-modern-zeguo',
    category: 'poem',
    dynasty: 'modern',
    title: '水鄉',
    source: '鄭愁予',
    description: '鄭愁予寫江南水鄉的溫柔與記憶。',
    content: '水鄉的溫柔，是屬於姑娘們的。她們的長髮如垂柳，她們的笑語如漣漪。而我的記憶，是一葉扁舟，在時間的河流中緩緩漂蕩。兩岸的燈火，明滅如星，織成一片迷離的夢境。船過水無痕，只有槳聲，一聲，又一聲，在夜的深處迴盪。',
  },

  {
    id: 'classic-beiying',
    category: 'classic',
    dynasty: 'modern',
    title: '背影',
    source: '朱自清',
    description: '朱自清以父親的背影為線索，寫父子情深，真摯動人。',
    content: '我與父親不相見已二年餘了，我最不能忘記的是他的背影。那年冬天，祖母死了，父親的差使也交卸了，正是禍不單行的日子。我從北京到徐州，打算跟著父親奔喪回家。到徐州見著父親，看見滿院狼藉的東起，又想起祖母，不禁簌簌地流下眼淚。父親說：「事已如此，不必難過，好在天無絕人之路！」回家變賣典質，父親還了虧空；又借錢辦了喪事。這些日子，家中光景很是慘澹，一半因為喪事，一半因為父親失業。喪事完畢，父親要到南京謀事，我也要回北京唸書，我們便同行。我們到了南京，父親因為事忙，本已說定不送我，叫旅館裡一個熟識的茶房陪我同去。他再三囑咐茶房，甚是仔細。但他終於不放心，怕茶房不妥帖；頗躊躇了一會。其實我那年已二十歲，北京已來往過兩三次，是沒有什麼要緊的。他躊躇了一會，終於決定還是自己送我去。我兩三回勸他不必去；他只說：「不要緊，他們去不好！」我們過了江，進了車站。我買票，他忙著照看行李。行李太多了，得向腳夫行些小費才可過去。他便又忙著和他們講價錢。我那時真是聰明過分，總覺得他說話不大漂亮，非自己插嘴不可，但他終於講定了價錢；送我上車。他給我揀定了靠車門的一張椅子；我將他給我的紫毛大衣鋪好座位。他囑我路上小心，夜裡要警醒些，不要受涼。又囑託茶房好好照應我。我心裡暗笑他的迂；他們只認得錢，託他們直是白託！而且我這樣大年紀的人，難道還不能料理自己麼？唉，我現在想想，那時真是太聰明了！他往車外看了看說：「我買幾個橘子去。你就在此地，不要走動。」我看那邊月台的柵欄外有幾個賣東西的等著顧客。走到那邊月台，須穿過鐵道，須跳下去又爬上去。父親是一個胖子，走過去自然要費事些。我本來要去的，他不肯，只好讓他去。我看見他戴著黑布小帽，穿著黑布大馬褂，深青布棉袍，蹣跚地走到鐵道邊，慢慢探身下去，尚不大難。可是他穿過鐵道，要爬上那邊月台，就不容易了。他用兩手攀著上面，兩腳再向上縮；他肥胖的身子向左微傾，顯出努力的樣子，這時我看見他的背影，我的淚很快地流下來了。我趕緊拭乾了淚。怕他看見，也怕別人看見。我再向外看時，他已抱了朱紅的橘子往回走了。過鐵道時，他先將橘子散放在地上，自己慢慢爬下，再抱起橘子走。到這邊時，我趕緊去攙他。他和我走到車上，將橘子一股腦兒放在我的皮大衣上。於是撲撲衣上的泥土，心裡很輕鬆似的。過一會說：「我走了，到那邊來信！」我望著他走出去。他走了幾步，回過頭看見我說：「進去吧，裡邊沒人。」等他的背影混入來來往往的人裡，再找不著了，我進來坐下，我的眼淚又來了。在晶瑩的淚光中，又看見那肥胖的、青布棉袍黑布馬褂的背影。我不知何時再能與他相見！',
  },

  {
    id: 'classic-congcong',
    category: 'classic',
    dynasty: 'modern',
    title: '匆匆',
    source: '朱自清',
    description: '朱自清感嘆時光流逝，勸人珍惜光陰。',
    content: '燕子去了，有再來的時候；楊柳枯了，有再青的時候；桃花謝了，有再開的時候。但是，聰明的，你告訴我，我們的日子為什麼一去不復返呢？——是有人偷了他們罷：那是誰？又藏在何處呢？是他們自己逃走了罷：如今又到了哪裡呢？我不知道他們給了我們多少日子，但我的手確乎是漸漸空虛了。在默默裡算著，八千多個日子已經從我手中溜去，像針尖上一滴水滴在大海裡，我的日子滴在時間的流裡，沒有聲音，也沒有影子。我不禁頭涔涔而淚潸潸了。去的儘管去了，來的儘管來著；去來的中間，又怎樣地匆匆呢？早上我起來的時候，小屋裡射進兩三方斜斜的太陽。太陽他有腳啊，輕輕悄悄地挪移了，我也茫茫然跟著旋轉。於是——洗手的時候，日子從水盆裡過去；吃飯的時候，日子從飯碗裡過去；默默時，便從凝然的雙眼前過去。我覺察他去的匆匆了，伸出手遮挽時，他又從遮挽著的手邊過去，天黑時，我躺在床上，他便伶伶俐俐地從我身上跨過，從我腳邊飛去了。等我睜開眼和太陽再見，這算又溜走了一日。我掩著面嘆息。但是新來的日子的影兒又開始在嘆息裡閃過了。在逃去如飛的日子裡，在千門萬戶的世界裡的我能做些什麼呢？只有徘徊罷了，只有匆匆罷了。在八千多個日子的匆匆裡，除徘徊外，又剩些什麼呢？過去的日子如輕煙，被微風吹散了，如薄霧，被初陽蒸融了；我留著些什麼痕跡呢？我何曾留著像游絲樣的痕跡呢？我赤裸裸來到這世界，轉眼間也將赤裸裸的回去罷？但不能平的，為什麼偏要白白走這一遭啊？你聰明的，告訴我，我們的日子為什麼一去不復返呢？',
  },

  {
    id: 'classic-chabuduo',
    category: 'classic',
    dynasty: 'modern',
    title: '差不多先生傳',
    source: '胡適',
    description: '胡適諷刺凡事馬虎了事的國民性，發人深省。',
    content: '你知道中國最有名的人是誰？提起此人，人人皆曉，處處聞名。他姓差，名不多，是各省各縣各村人氏。你一生一定見過他，也一定聽過別人談起他。差不多先生的名字天天掛在大家的口頭上，因為他一生不肯認真，不肯算帳，不肯計較。差不多先生的相貌和你我都差不多。他有一雙眼睛，但看得不很清楚；有兩隻耳朵，但聽得不很分明；有鼻子和嘴，但他對於氣味和口味都不很講究。他的腦子也不小，但他的記憶力卻不很強，他的想法也不很細密。他常常說：「凡事只要差不多就好了。何必太精明呢？」他小的時候，他媽叫他去買紅糖，他買了白糖回來。他媽罵他，他搖搖頭說：「紅糖白糖不是差不多嗎？」他在學堂的時候，先生問他：「直隸省的西邊是哪一省？」他說是陝西。先生說：「錯了。是山西，不是陝西。」他說：「陝西山西不是差不多嗎？」後來他在一個錢鋪裡做夥計，他也會寫，也會算，但總不精細，紅字常常寫成赤字，三字常常寫成十字。老闆生氣了，常常罵他。他只是笑嘻嘻地賠禮道：「千字萬字不是差不多嗎？三十跟三不是差不多嗎？」有一天，他為了一件要緊的事，要搭火車到上海去。他急急忙忙地跑到火車站，遲了兩分鐘，火車已開走了。他望著遠去的火車，搖搖頭說：「差不多！火車走了，明天再走也差不多！」',
  },

  {
    id: 'poem-modern-xuehua',
    category: 'poem',
    dynasty: 'modern',
    title: '雪花',
    source: '徐志摩',
    description: '徐志摩寫雪花的飄逸與純粹。',
    content: '假如我是一朵雪花，翩翩的在半空裡瀟洒，我一定認清我的方向，飛颺，飛颺，飛颺——這地面上有我的方向。',
  },

  {
    id: 'radical-1-yi',
    category: 'radical',
    dynasty: 'modern',
    title: '一部 (1劃)',
    source: '相同部首',
    description: '常見一部字：一、丁、七、丈、三、下、上、且、世、丘、丙、丟、乘、万、丰、丐、丕、互、井、亞',
    content: '一 丁 七 丈 三 下 上 且 世 丘 丙 丟 乘 万 丰 丐 丕 互 井 亞',
  },

  {
    id: 'radical-2-ren',
    category: 'radical',
    dynasty: 'modern',
    title: '人部 (2劃)',
    source: '相同部首',
    description: '常見人部（亻）字：你、他、們、仔、什、介、仍、代、付、仙、仕、仗、份、仿、伐、休、伏、仲、件、任',
    content: '你 他 們 仔 什 介 仍 代 付 仙 仕 仗 份 仿 伐 休 伏 仲 件 任',
  },

  {
    id: 'radical-3-kou',
    category: 'radical',
    dynasty: 'modern',
    title: '口部 (3劃)',
    source: '相同部首',
    description: '常見口部字：口、叫、古、右、占、叮、叩、只、叭、史、司、唱、喝、喜、喚、喧、嗷、嘯、嘴、器',
    content: '口 叫 古 右 占 叮 叩 只 叭 史 司 唱 喝 喜 喚 喧 嗷 嘯 嘴 器',
  },

  {
    id: 'radical-3-water',
    category: 'radical',
    dynasty: 'modern',
    title: '水部 (3劃)',
    source: '相同部首',
    description: '常見三點水（氵）字：江、河、湖、海、溪、池、波、浪、流、潮、游、灑、漸、灌、溉、源、湧、淚、汗、泥',
    content: '江 河 湖 海 溪 池 波 浪 流 潮 游 灑 漸 灌 溉 源 湧 淚 汗 泥',
  },

  {
    id: 'radical-3-grass',
    category: 'radical',
    dynasty: 'modern',
    title: '草部 (3劃)',
    source: '相同部首',
    description: '常見草部（艹）字：花、草、葉、蓮、芬、芳、落、英、茶、藥、華、莫、著、蒲、萍、蒼、蒙、蒸、暮、蓋',
    content: '花 草 葉 蓮 芬 芳 落 英 茶 藥 華 莫 著 蒲 萍 蒼 蒙 蒸 暮 蓋',
  },

  {
    id: 'radical-3-walk',
    category: 'radical',
    dynasty: 'modern',
    title: '辵部 (3劃)',
    source: '相同部首',
    description: '常見辵部（辶）字：道、路、迎、送、追、退、進、速、遍、過、迷、逝、遠、廷、述、迪、迴、避、造、通',
    content: '道 路 迎 送 追 退 進 速 遍 過 迷 逝 遠 廷 述 迪 迴 避 造 通',
  },

  {
    id: 'radical-3-hand',
    category: 'radical',
    dynasty: 'modern',
    title: '手部 (3劃)',
    source: '相同部首',
    description: '常見手部（手/扌）字：持、打、招、提、排、推、折、掉、掃、描、揮、扶、批、抄、找、承、投、抓、押、抽',
    content: '持 打 招 提 排 推 折 掉 掃 描 揮 扶 批 抄 找 承 投 抓 押 抽',
  },

  {
    id: 'radical-3-heart',
    category: 'radical',
    dynasty: 'modern',
    title: '心部 (3劃)',
    source: '相同部首',
    description: '常見心部（心/忄）字：思、想、念、悲、怒、怨、急、怎、忘、意、憂、怕、恨、恆、悄、悼、悽、情、惜、懷',
    content: '思 想 念 悲 怒 怨 急 怎 忘 意 憂 怕 恨 恆 悄 悼 悽 情 惜 懷',
  },

  {
    id: 'radical-4-wood',
    category: 'radical',
    dynasty: 'modern',
    title: '木部 (4劃)',
    source: '相同部首',
    description: '常見木部字：林、森、枝、梅、根、橋、樣、校、機、樹、梢、桃、柳、欄、梓、棋、植、綿、楚、榮',
    content: '林 森 枝 梅 根 橋 樣 校 機 樹 梢 桃 柳 欄 梓 棋 植 棉 楚 榮',
  },

  {
    id: 'radical-4-fire',
    category: 'radical',
    dynasty: 'modern',
    title: '火部 (4劃)',
    source: '相同部首',
    description: '常見火部（火/灬）字：火、燈、煙、煤、燒、烤、照、熱、烈、煮、燃、爛、炒、熄、炭、烽、烘、焦、然、熙',
    content: '火 燈 煙 煤 燒 烤 照 熱 烈 煮 燃 爛 炒 熄 炭 烽 烘 焦 然 熙',
  },

  {
    id: 'radical-5-jade',
    category: 'radical',
    dynasty: 'modern',
    title: '玉部 (5劃)',
    source: '相同部首',
    description: '常見玉部（玉/王）字：王、玩、玲、珍、玻、珂、珊、班、珮、現、琪、琳、琢、琴、琵、琶、瑰、璀、璃、環',
    content: '王 玩 玲 珍 玻 珂 珊 班 珮 現 琪 琳 琢 琴 琵 琶 瑰 璀 璃 環',
  },

  {
    id: 'radical-6-bamboo',
    category: 'radical',
    dynasty: 'modern',
    title: '竹部 (6劃)',
    source: '相同部首',
    description: '常見竹部字：竹、竿、笆、笈、笑、笛、笠、筆、等、筋、筏、筐、答、策、篩、箏、簡、簿、籍、籤',
    content: '竹 竿 笆 笈 笑 笛 笠 筆 等 筋 筏 筐 答 策 篩 箏 簡 簿 籍 籤',
  },

  {
    id: 'radical-6-ear',
    category: 'radical',
    dynasty: 'modern',
    title: '耳部 (6劃)',
    source: '相同部首',
    description: '常見耳部字：耳、耶、耽、耿、聊、聆、聖、聘、聚、聞、聯、聰、聲、職、聽、聳、聒、聵、聶、聾',
    content: '耳 耶 耽 耿 聊 聆 聖 聘 聚 聞 聯 聰 聲 職 聽 聳 聒 聵 聶 聾',
  },

  {
    id: 'radical-7-speech',
    category: 'radical',
    dynasty: 'modern',
    title: '言部 (7劃)',
    source: '相同部首',
    description: '常見言部（言/訁）字：說、話、語、信、講、論、讀、譯、評、謙、設、許、訪、試、詩、誠、謀、誰、謝、證',
    content: '說 話 語 信 講 論 讀 譯 評 謙 設 許 訪 試 詩 誠 謀 誰 謝 證',
  },

  {
    id: 'radical-7-metal',
    category: 'radical',
    dynasty: 'modern',
    title: '金部 (7劃)',
    source: '相同部首',
    description: '常見金部（金/釒）字：金、針、釘、釣、鈕、鈔、鋼、鐵、銅、銀、鏡、鍾、錢、鋪、鍊、銷、錄、銳、鋒、鎖',
    content: '金 針 釘 釣 鈕 鈔 鋼 鐵 銅 銀 鏡 鍾 錢 鋪 鍊 銷 錄 銳 鋒 鎖',
  },

  {
    id: 'radical-8-rain',
    category: 'radical',
    dynasty: 'modern',
    title: '雨部 (8劃)',
    source: '相同部首',
    description: '常見雨部字：雨、雪、雯、雲、零、雷、電、需、震、霍、霓、霖、霜、霞、霧、霾、靂、靄、霸、露',
    content: '雨 雪 雯 雲 零 雷 電 需 震 霍 霓 霖 霜 霞 霧 霾 靂 靄 霸 露',
  },

  {
    id: 'radical-9-page',
    category: 'radical',
    dynasty: 'modern',
    title: '頁部 (9劃)',
    source: '相同部首',
    description: '常見頁部字：頂、頃、項、順、須、預、頑、頒、頓、頗、領、額、頤、題、顏、願、顛、類、顧、顯',
    content: '頂 頃 項 順 須 預 頑 頒 頓 頗 領 額 頤 題 顏 願 顛 類 顧 顯',
  },

  {
    id: 'radical-10-horse',
    category: 'radical',
    dynasty: 'modern',
    title: '馬部 (10劃)',
    source: '相同部首',
    description: '常見馬部字：馬、馭、馱、馳、駐、駕、駛、駒、駝、駟、駢、駿、騁、騎、騙、驅、驗、驚、驢、驟',
    content: '馬 馭 馱 馳 駐 駕 駛 駒 駝 駟 駢 駿 騁 騎 騙 驅 驗 驚 驢 驟',
  },

  {
    id: 'radical-11-fish',
    category: 'radical',
    dynasty: 'modern',
    title: '魚部 (11劃)',
    source: '相同部首',
    description: '常見魚部字：魚、魯、魷、魨、鮃、鮪、鮭、鮫、鮮、鯉、鯊、鯽、鯨、鯧、鰓、鰻、鱉、鱗、鱒、魴',
    content: '魚 魯 魷 魨 鮃 鮪 鮭 鮫 鮮 鯉 鯊 鯽 鯨 鯧 鰓 鰻 鱉 鱗 鱒 魴',
  },

  {
    id: 'radical-12-black',
    category: 'radical',
    dynasty: 'modern',
    title: '黑部 (12劃)',
    source: '相同部首',
    description: '常見黑部字：黑、墨、黔、默、黛、黜、黝、點、黠、黨、黯、黴、黶、黷、黲、黥、黧、黮、黰、黵',
    content: '黑 墨 黔 默 黛 黜 黝 點 黠 黨 黯 黴 黶 黷 黲 黥 黧 黮 黰 黵',
  },

  {
    id: 'radical-13-stroke',
    category: 'radical',
    dynasty: 'modern',
    title: '鼓/鼠/鼎/黽部 (13劃)',
    source: '相同部首',
    description: '十三劃部首包含鼓、鼠、鼎、黽等，筆畫繁多且具象性強',
    content: '鼓 鼕 鼠 鼬 鼴 鼯 鼩 鼦 鼨 鼫 鼱 鼲 鼷 鼎 鼐 鼒 黽 黿 鼇 鼉',
  },

  {
    id: 'radical-14-stroke',
    category: 'radical',
    dynasty: 'modern',
    title: '鼻/齊部 (14劃)',
    source: '相同部首',
    description: '十四劃部首包含鼻、齊等，結構複雜，著重重心穩定與部件避讓',
    content: '鼻 鼽 鼾 齁 鼿 齀 齂 齄 齅 齆 齇 齈 齉 齊 齋 齌 齍 齎 齏 齃',
  },

  {
    id: 'radical-15-tooth',
    category: 'radical',
    dynasty: 'modern',
    title: '齒部 (15劃)',
    source: '相同部首',
    description: '常見齒部字，筆畫多且結構均勻，適合練習精細硬筆控制',
    content: '齒 齡 齦 齟 齬 齪 齷 齲 齣 齧 齔 齕 齗 齘 齚 齠 齩 齮 齯 齶',
  },

  {
    id: 'common-high-freq-1',
    category: 'common',
    dynasty: 'modern',
    title: '常用高頻字一',
    source: '常用字例字',
    description: '最常用的漢字（第 1-25 位）：基礎常用高頻字練習。',
    content: '的 一 是 我 國 在 了 有 大 這 主 中 人 上 代 以 學 分 生 會 和 出 三 下',
  },

  {
    id: 'common-high-freq-2',
    category: 'common',
    dynasty: 'modern',
    title: '常用高頻字二',
    source: '常用字例字',
    description: '最常用的漢字（第 26-50 位）：進階常用高頻字練習。',
    content: '同 民 發 工 地 自 個 前 最 新 言 加 理 者 行 作 本 信 得 面 起 樣',
  },

  {
    id: 'common-high-freq-3',
    category: 'common',
    dynasty: 'modern',
    title: '常用高頻字三',
    source: '常用字例字',
    description: '最常用的漢字（第 51-75 位）：高頻字形結構對稱練習。',
    content: '家 美 開 當 年 動 性 成 子 意 多 裡 心 去 政 只 法 各 點 無 野 光 照',
  },

  {
    id: 'common-high-freq-4',
    category: 'common',
    dynasty: 'modern',
    title: '常用高頻字四',
    source: '常用字例字',
    description: '最常用的漢字（第 76-100 位）：日常對話、寫作極高頻字練習。',
    content: '那 都 如 她 他 們 說 著 要 去 好 看 小 天 來 去 沒 時 能 能 回 日 裡',
  },

  {
    id: 'common-high-freq-5',
    category: 'common',
    dynasty: 'modern',
    title: '常用高頻字五',
    source: '常用字例字',
    description: '最常用的漢字（第 101-125 位）：日常用字，練習結構穩定度。',
    content: '過 頭 經 頭 面 長 公 立 意 很 但 自 道 只 前 把 更 特 表 治 被 己',
  },

  {
    id: 'common-high-freq-6',
    category: 'common',
    dynasty: 'modern',
    title: '常用高頻字六',
    source: '常用字例字',
    description: '最常用的漢字（第 126-150 位）：日常用字，適合練習重心和比例。',
    content: '整 通 感 度 結 老 正 問 次 身 聞 物 非 相 應 最 期 望 當 提 現 實',
  },

  {
    id: 'common-single-component',
    category: 'common',
    dynasty: 'modern',
    title: '獨體字 (筆畫簡單)',
    source: '常用字例字',
    description: '結構簡單的獨體字，適合練習基本筆畫與結構對稱性',
    content: '一 乙 二 十 丁 厂 七 卜 人 入 八 九 几 兒 了 力 乃 刀 又 三 于 干 工',
  },

  {
    id: 'common-left-right',
    category: 'common',
    dynasty: 'modern',
    title: '左右結構常用字',
    source: '常用字例字',
    description: '左右寬窄比例與避讓練習',
    content: '你 他 們 說 話 語 靜 明 湘 順 願 影 都 鄰 聽 輔 輕 軟 較 輔 輪 補 助',
  },

  {
    id: 'common-left-mid-right',
    category: 'common',
    dynasty: 'modern',
    title: '左中右結構常用字',
    source: '常用字例字',
    description: '左中右三部分橫向排布比例與筆畫避讓練習。',
    content: '街 辦 樹 謝 搬 腳 粥 漸 斑 辯 辦 側 撕 概 膨 攤 懶 撇 微 潮 澎 哪',
  },

  {
    id: 'common-up-down',
    category: 'common',
    dynasty: 'modern',
    title: '上下結構常用字',
    source: '常用字例字',
    description: '上下重心對齊與比例練習',
    content: '花 草 葉 意 志 思 想 念 聖 塵 雲 雪 零 霜 麗 晨 昏 舊 冒 宣 宴 官',
  },

  {
    id: 'common-up-mid-down',
    category: 'common',
    dynasty: 'modern',
    title: '上中下結構常用字',
    source: '常用字例字',
    description: '上中下三部分縱向對齊、層次勻稱練習。',
    content: '意 等 莫 藍 茶 繁 驚 囊 冀 薯 裹 葛 蓄 暴 幕 馨 蓋 蔑 冤 羨 蔓 騫',
  },

  {
    id: 'common-enclosed',
    category: 'common',
    dynasty: 'modern',
    title: '包圍結構常用字',
    source: '常用字例字',
    description: '半包圍或全包圍字，內外空間均衡分配練習',
    content: '國 園 圈 圍 回 因 固 圖 處 遞 遠 邁 迴 避 句 包 旬 甸 司 同 后 向',
  },

  {
    id: 'common-pin-shaped',
    category: 'common',
    dynasty: 'modern',
    title: '品字形結構常用字',
    source: '常用字例字',
    description: '三個相同偏旁字堆疊的字，練習大小筆畫避讓與空間分佈。',
    content: '森 淼 焱 磊 晶 眾 品 聶 轟 協 姦 矗 鱻 驫 麤 掱 蠱 毳 劦 厵 雥',
  },

  {
    id: 'common-complex-strokes',
    category: 'common',
    dynasty: 'modern',
    title: '難寫/繁複常用字',
    source: '常用字例字',
    description: '筆畫繁複、結構細密的常用字，考驗結構掌控力與硬筆精細度。',
    content: '囊 鑿 鬱 釁 麟 驪 爨 齲 龐 籠 護 譽 鑰 廳 警 霸 戀 攀 響 屬 巍 霸',
  },

  {
    id: 'lyrics-qinghuaci',
    category: 'lyrics',
    dynasty: 'modern',
    title: '青花瓷',
    source: '方文山 (周杰倫演唱)',
    description: '經典中國風歌曲，歌詞描繪青花瓷的優雅意境。',
    content: '素胚勾勒出青花筆鋒濃轉淡，瓶身描繪的牡丹一如妳初妝。冉冉檀香透過窗心事我了然，宣紙上走筆至此擱一半。釉色渲染仕女圖韻味被私藏，而妳嫣然的一笑如含苞待放。妳的美一縷飄散，去到我去不了的地方。天青色等煙雨，而我在等妳。炊煙裊裊昇起，隔江千萬里。在瓶底書漢隸仿前朝的飄逸，就當我為遇見妳伏筆。天青色等煙雨，而我在等妳。月色被打撈起，暈開了結局。如傳世的青花瓷自顧自美麗，妳眼帶笑意。色白花青的錦鯉躍然於碗底，臨摹宋體落款時卻惦記著妳。妳隱藏在窯燒裡千年的秘密，極細膩猶如繡花針落地。簾外芭蕉惹驟雨，門環惹銅綠。而我路過那江南小鎮惹了妳。在潑墨山水畫裡，妳從墨色深處被隱去。',
  },

  {
    id: 'lyrics-shengshengman',
    category: 'lyrics',
    dynasty: 'modern',
    title: '聲聲慢',
    source: '崔開潮',
    description: '將宋詞意境融入現代民謠，旋律與歌詞皆具古典美。',
    content: '青磚伴瓦漆，白馬踏新泥。山花蕉葉暮色叢染紅巾。屋檐灑雨滴，炊煙裊裊起。蹉跎輾轉宛然的你在哪裡。尋尋覓覓，冷冷清清，月落烏啼月牙落孤井。零零碎碎，點點滴滴，夢裡有花夢裡青草地。長髮引漣漪，白布展石磯。河童撐桿擺長舟渡古稀。屋檐灑雨滴，炊煙裊裊起。蹉跎輾轉宛然的你在哪裡。尋尋覓覓，冷冷清清，月落烏啼月牙落孤井。零零碎碎，點點滴滴，夢裡有花夢裡青草地。',
  },

  {
    id: 'lyrics-yanhuayileng',
    category: 'lyrics',
    dynasty: 'modern',
    title: '煙花易冷',
    source: '方文山 (周杰倫演唱)',
    description: '改編自《洛陽伽藍記》，描述將軍與女子的淒美愛情故事。',
    content: '繁華聲遁入空門折煞了世人，夢偏冷輾轉一生情債又幾本。如妳默認生死枯等，枯等一圈又一圈的年輪。浮屠塔斷了幾層斷了誰的魂，痛直奔一盞殘燈傾塌的山門。容我再等歷史轉身，等酒香醇等妳彈一曲古箏。雨紛紛舊故里草木深，我聽聞妳始終一個人。斑駁的城門盤踞著老樹根，石板上迴盪的是再等。雨紛紛舊故里草木深，我聽聞妳仍守著孤城。城郊牧笛聲落在那座野村，緣份落地生根是我們。聽青春迎來笑聲羨煞許多人，那史冊溫柔不肯下筆都太狠。煙花易冷人事易分，而妳在問我是否還認真。千年後累世情深還有誰在等，而青史豈能不真魏書洛陽城。如妳在跟前世過門，跟著紅塵跟隨我浪跡一生。',
  },

  {
    id: 'lyrics-jiahutai',
    category: 'lyrics',
    dynasty: 'modern',
    title: '菊花台',
    source: '方文山 (周杰倫演唱)',
    description: '電影《滿城盡帶黃金甲》主題曲，歌詞哀怨感傷，富含畫面感。',
    content: '妳的淚光，柔弱中帶傷。慘白的月彎彎，勾住過往。夜太漫長，凝結成了霜。是誰在閣樓上冰冷地絕望。雨輕輕彈，朱紅色的窗。我一生在紙上被風吹亂。茫然的雙眼，看不見憂傷。妳哭紅的雙眼，我心事靜靜躺。菊花殘，滿地傷，花落人斷腸。我心事靜靜躺。北風亂，夜未央，妳的影子剪不斷。徒留我孤單在湖面成雙。花已向晚，飄落了燦爛。凋謝的世道上，命運不堪。愁莫渡江，秋心拆兩半。怕妳孤單，泥土為妳疊起重重傷。',
  },

  {
    id: 'lyrics-dongfengpo',
    category: 'lyrics',
    dynasty: 'modern',
    title: '東風破',
    source: '方文山 (周杰倫演唱)',
    description: '中國風流行音樂開山之作，借「東風破」古琵琶曲牌名抒發離愁。',
    content: '一盞離愁，孤單佇立在窗口。琵琶聲，聽袖擺招展。誰在用琵琶彈奏一曲東風破，歲月在牆上剝落看見小時候。猶記得那年我們都還很年幼，而如今琴聲幽幽，我的等候妳沒聽過。誰在用琵琶彈奏一曲東風破，楓葉將故事染色結局我看透。籬笆外的古道我牽著馬走過，荒煙蔓草的年頭，就連分手都很沉默。誰在用琵琶彈奏一曲東風破，歲月在牆上剝落看見小時候。猶記得那年我們都還很年幼，而如今琴聲幽幽，我的等候妳沒聽過。誰在用琵琶彈奏一曲東風破，楓葉將故事染色結局我看透。籬笆外的古道我牽著馬走過，荒煙蔓草的年頭，就連分手都很沉默。',
  },

  {
    id: 'lyrics-hongchenkezhan',
    category: 'lyrics',
    dynasty: 'modern',
    title: '紅塵客棧',
    source: '方文山 (周杰倫演唱)',
    description: '展現江湖俠氣與兒女情長的中國風佳作。',
    content: '天涯的盡頭是風沙，紅塵的故事愛恨交加。折戟沉沙秋水無涯，誰又是英雄被歷史刻下。我身騎白馬，浪跡天涯，唯獨對妳一生牽掛。紅塵客棧風似刀，驟雨落，宿命敲。任武林誰領風騷，我卻只為妳折腰。過往的恩怨澆一碗酒，在黃昏的夕陽下，風聲使者敲。妳在草棚下，細數著白髮，我一邊描摹妳的年華。國仇家恨一筆抹煞，唯有妳的容顏難以放下。',
  },

  {
    id: 'lyrics-dayu',
    category: 'lyrics',
    dynasty: 'modern',
    title: '大魚',
    source: '尹約 (周深演唱)',
    description: '動畫電影《大魚海棠》印象曲，歌詞空靈深邃。',
    content: '海浪無聲將夜幕深深淹沒，漫過天空盡頭的角落。大魚在夢境的縫隙裡游過，凝望你沉睡的輪廓。看海天一色，聽風起雨落，執子手吹散蒼茫茫煙波。大魚的翅膀已經太遼闊，我鬆開時間的繩索。怕你飛遠去，怕你離我而去，更怕你永遠停留在這裡。每一滴淚水都向你流淌去，倒流進天空的海底。看你飛遠去，看你離我而去，原來你生來就屬於天際。每一滴淚水都向你流淌去，倒流回最初的相遇。',
  },

  {
    id: 'lyrics-zhifuzhifu',
    category: 'lyrics',
    dynasty: 'modern',
    title: '知否知否',
    source: '張靖怡 (胡夏/郁可唯演唱)',
    description: '電視劇《知否？知否？應是綠肥紅瘦》主題曲，結合李清照詞作。',
    content: '一朝花開傍柳，尋香誤入深秋。昨夜風疏雨驟，濃睡不消殘酒。試問捲簾人，卻道海棠依舊。知否，知否？應是綠肥紅瘦。昨夜風疏雨驟，濃睡不消殘酒。試問捲簾人，卻道海棠依舊。知否，知否？應是綠肥紅瘦。知否，知否？應是綠肥紅瘦。',
  },

  {
    id: 'lyrics-juanzhulian',
    category: 'lyrics',
    dynasty: 'modern',
    title: '卷珠簾',
    source: 'LUNA (霍尊演唱)',
    description: '帶有濃厚古典幽怨色彩的抒情曲。',
    content: '鐫刻好每道眉間心上，畫間透過思量，沾染了墨色淌，千家文盡泛黃，夜靜謐窗紗微微亮。拂袖起舞於夢中嫵媚，相思蔓上心扉，猶眷戀梨花淚，靜畫紅妝等誰歸，空留伊人徐徐憔悴。啊，胭脂香味，卷珠簾是為誰。啊，高軒霧褪，夜月明袖掩暗垂淚。細雨酥潤見煙外綠楊，倦起愁對春傷，殘燭化曉風涼，歸雁過處留聲悵，天水間誰撫琴斷腸。',
  },

  {
    id: 'lyrics-hongdou',
    category: 'lyrics',
    dynasty: 'modern',
    title: '紅豆',
    source: '林夕 (王菲演唱)',
    description: '情意綿密，將思念寄託於紅豆的華語經典。',
    content: '還沒好好的感受，雪花綻放的氣候。我們一起顫抖，會更明白什麼是溫柔。還沒跟你牽著手，走過荒蕪的沙丘。可能從此以後，學會珍惜天長和地久。有時候，有時候，我會相信一切有盡頭。相聚離開都有時候，沒有什麼會永垂不朽。可是我，有時候，寧願選擇留戀不放手。等到風景都看透，也許你會陪我看細水長流。還沒為你把紅豆，熬成纏綿的傷口。然後一起分享，會更明白相思的哀愁。還沒好好的感受，醒著親吻的溫柔。可能在我左右，你才追求孤獨的自由。',
  },

  {
    id: 'lyrics-jiangnan',
    category: 'lyrics',
    dynasty: 'modern',
    title: '江南',
    source: '李瑞洵 (林俊傑演唱)',
    description: '描寫江南雨景與緣分糾葛的經典流行歌。',
    content: '風到這裡就是黏，黏住過客的思念。雨到了這裡纏成線，纏著我們留戀人世間。妳在身邊就是緣，緣分寫在三生石上面。愛恨兩茫茫，問君能有幾多愁，恰似一江春水向東流。不懂愛恨情仇煎熬的我們，都以為相愛就像風雲的善變。相信愛一天，抵過永遠。在兩手相扣間，這怨恨能有幾多愁。',
  },

  {
    id: 'lyrics-liangliang',
    category: 'lyrics',
    dynasty: 'modern',
    title: '涼涼',
    source: '劉暢 (張碧晨/楊宗緯演唱)',
    description: '仙俠劇主題曲，歌詞充滿三生三世的宿命感。',
    content: '入夜漸微涼，繁花落地成霜。妳在遠方眺望，耗盡三生三世的時光。涼涼夜色為妳思念成河，化作春泥呵護著我。折一枝寒梅，贈予伊人，願歲月不老，願妳我無恙。涼涼天意，灩灩隨波千萬里，看透了人間的悲歡離合。涼涼腔調，灩灩隨波逐浪去，願生生世世的相守，能抵擋這世間的冰霜。',
  },

  {
    id: 'lyrics-qingmingyushang',
    category: 'lyrics',
    dynasty: 'modern',
    title: '清明雨上',
    source: '許嵩',
    description: '曲風典雅哀傷，借清明雨景緬懷逝去之愛。',
    content: '窗透初曉，日照西橋，雲自搖。想你當年荷風微擺的衣角。木雕流金，歲月漣漪，七葉明芝。折菊寄到你身旁，把你淚水擦乾。清明雨上，摺子戲落幕，而你在何方。雨紛紛，舊故里草木深。我聽聞，你始終一個人。雨紛紛，舊故里草木深。我聽聞，你仍守著孤城。城郊牧笛聲，落在那座野村，緣份落地生根是我們。',
  },

  {
    id: 'lyrics-luzhouyue',
    category: 'lyrics',
    dynasty: 'modern',
    title: '廬州月',
    source: '許嵩',
    description: '融古典文學意象與懷人思鄉於一爐。',
    content: '兒時鑿壁偷光，讀書聲清朗。如今千山萬水，塵土滿衣裳。廬州月光，灑在心上，月下的你是否一如往常。橋上的誓言，隨流水飄向遠方，而我依然在等你的歸航。烏篷船，聽雨眠，一曲琵琶撥動了心弦。廬州月光，梨花雨涼，思念在風中微微搖晃。',
  },

  {
    id: 'lyrics-qianbudu',
    category: 'lyrics',
    dynasty: 'modern',
    title: '千百度',
    source: '許嵩',
    description: '取意於辛棄疾《青玉案》，古典雅致。',
    content: '關外野店，煙火點點。你在石板街，輕輕的走過。暮色起看天邊斜陽，恍惚間想起你的模樣。千百度尋你，你卻在燈火闌珊處，而我依然守候在最初的渡口。借一盞清茶，聽風起雨落，寫下三生的期盼。千百度尋你，你卻在燈火闌珊處。',
  },

  {
    id: 'lyrics-buran',
    category: 'lyrics',
    dynasty: 'modern',
    title: '不染',
    source: '海雷 (毛不易演唱)',
    description: '古裝劇插曲，寫盡仙俠世界中的超然與不捨。',
    content: '不願染是與非，怎料事與願違。心中的花枯萎，眼角的淚滑落。一壺清酒，折一枝寒梅，看透世間繁華與落寞。願洗淨鉛華，不染塵埃，與你共度餘生漫漫。回首往事，皆是過眼雲煙，唯有你的容顏不曾忘記。一念成執，不染纖塵。',
  },

  {
    id: 'lyrics-xiaochou',
    category: 'lyrics',
    dynasty: 'modern',
    title: '消愁',
    source: '毛不易',
    description: '具備詩意與現代都市感傷的現象級歌詞。',
    content: '當你走進這歡樂場，背上所有的夢與想。各色的臉上各色的妝，沒人記得你的模樣。三巡酒過你在角落，固執地唱著苦澀的歌。聽它在喧囂裡被淹沒，你拿起酒杯對自己說：一杯敬朝陽，一杯敬月光，喚醒我的嚮往，溫暖了我的心房。一杯敬故鄉，一杯敬遠方，守護我的善良，催著我成長。一杯敬明天，一杯敬過往，人生路漫漫。一杯敬自由，一杯敬死亡，寬恕我的平凡，驅散了迷惘。好吧天亮之後總是潦草離場，清醒的人最荒唐。',
  },

  {
    id: 'lyrics-hongzhaoyuan',
    category: 'lyrics',
    dynasty: 'modern',
    title: '紅昭願',
    source: '荒唐客 (音闕詩聽演唱)',
    description: '國風電音名曲，曲調與歌詞皆具節奏美。',
    content: '手中雕刻生花，刀鋒千轉蜿蜒成畫。盛名功德塔，是橋畔某處人家。春風繞過髮梢，紅紗刺繡贈他。眉目剛烈擬作妝嫁。轟烈流沙，枕上白髮。杯中酒比劃，年少風雅.鮮衣怒馬，也不過一剎那。難免疏漏，兒時簷下莫測變化。隔卻山海，轉身從容煎茶。重寄一段過往，將希冀都流放。可曾添些荒唐，才記得你的模樣。誰提筆只兩行，換一隅你安康。便銷得這滄桑，你還在我的心上。',
  },

  {
    id: 'lyrics-mangzhong',
    category: 'lyrics',
    dynasty: 'modern',
    title: '芒種',
    source: '假寐 (音闕詩聽演唱)',
    description: '以二十四節氣為名的洗腦國風流行歌詞。',
    content: '一想到你我就空恨別夢久，燒去紙灰埋煙柳。於鮮活的枝芽，凋零下的無暇，是收穫謎底的代價。餘暉沾上遠行人的髮，他撒下手中牽掛，於橋下。前世遲來者，擦肩而過。掌心刻來生記得，你眼中煙波滴落一滴墨。若佛說無牽無掛，放下執著，無相無色，我怎能波瀾不驚去附和。一想到你我就空恨別夢久。新翠徒留落花影中游。相思無用才笑山盟舊。防不勝防。',
  },

  {
    id: 'lyrics-dayuhaitang',
    category: 'lyrics',
    dynasty: 'modern',
    title: '大魚海棠',
    source: '經典電影插曲歌詞',
    description: '電影《大魚海棠》主題相關，富有生命的哲理與期盼。',
    content: '星月相掩於大海上，微風搖曳細雨也彷徨。流霞飛舞，群青深處，你我曾相遇的地方。你是否已化作風雨，穿越時光來到這裡。秋去春來，海棠花開，你在夢裡我不願醒來。每條大魚都會相遇，每個人都會重聚。生命旅程往復不息，每個夢都會有你。秋去春來，海棠花開，你在夢裡我不願醒來。每條大魚都會相遇，每一個人都會重聚。生命旅程往復不息，每一個夢都會有你。',
  },

  {
    id: 'structure-rule-1',
    category: 'structure',
    dynasty: 'modern',
    title: '01. 天覆法',
    source: '間架結構32法',
    description: '頂頭重而下輕，如覆蓋之狀。上面要蓋住下面。',
    content: '雨 雪 雲 雷 霜 露 宇 官 宮 空 家 寫 憲 室',
  },

  {
    id: 'structure-rule-2',
    category: 'structure',
    dynasty: 'modern',
    title: '02. 地載法',
    source: '間架結構32法',
    description: '底頭重而上輕，如地載之狀。底橫要托住上面。',
    content: '直 且 至 立 旦 土 王 宣 孟 盛 益 蓋 鹽',
  },

  {
    id: 'structure-rule-3',
    category: 'structure',
    dynasty: 'modern',
    title: '03. 分合法',
    source: '間架結構32法',
    description: '左右分合者，如雙翼之狀。左右要分合對稱。',
    content: '八 分 人 合 谷 介 父 公 兮 琴 眷 盆 谷',
  },

  {
    id: 'structure-rule-4',
    category: 'structure',
    dynasty: 'modern',
    title: '04. 向背法',
    source: '間架結構32法',
    description: '左右向背者，如相揖相背之狀。要向背有情、相讓相迎。',
    content: '非 門 州 北 兆 冊 乘 飛 兩 姬 雙 聯 肄',
  },

  {
    id: 'structure-rule-5',
    category: 'structure',
    dynasty: 'modern',
    title: '05. 偏側法',
    source: '間架結構32法',
    description: '字之偏側者，如偏向一方。要偏而不倒、斜中取正。',
    content: '勿 力 方 乃 刀 夕 少 戈 易 身 多 勻',
  },

  {
    id: 'structure-rule-6',
    category: 'structure',
    dynasty: 'modern',
    title: '06. 排疊法',
    source: '間架結構32法',
    description: '字之排疊者，如多橫或多豎，間隔要均勻疏密。',
    content: '壽 書 畫 憲 量 重 意 畫 義 豐 講 繁 叢',
  },

  {
    id: 'structure-rule-7',
    category: 'structure',
    dynasty: 'modern',
    title: '07. 避讓法',
    source: '間架結構32法',
    description: '合體字左右或上下，部首與主體要互相避讓。',
    content: '林 妙 秋 竹 鳴 謝 體 辦 雙 雜 讀 聽 樹',
  },

  {
    id: 'structure-rule-8',
    category: 'structure',
    dynasty: 'modern',
    title: '08. 迎讓法',
    source: '間架結構32法',
    description: '左右結構或上下結構中，筆畫交錯迎讓穿插。',
    content: '繁 馨 聲 響 饗 警 攀 鴛 鴦 攀 鑿 鬱 囊',
  },

  {
    id: 'structure-rule-9',
    category: 'structure',
    dynasty: 'modern',
    title: '09. 寬窄法',
    source: '間架結構32法',
    description: '字之寬窄，要長短寬窄合度，結構平穩。',
    content: '目 耳 日 月 四 田 西 國 園 口 百 白 回',
  },

  {
    id: 'structure-rule-10',
    category: 'structure',
    dynasty: 'modern',
    title: '10. 長短法',
    source: '間架結構32法',
    description: '字之長短者，長者立，短者方，各有體態。',
    content: '自 身 目 耳 口 日 白 四 几 卜 人 八 九',
  },

  {
    id: 'structure-rule-11',
    category: 'structure',
    dynasty: 'modern',
    title: '11. 相讓法',
    source: '間架結構32法',
    description: '左右結構的部件互相妥協讓出空間，保持整體美感。',
    content: '和 知 細 功 動 唱 話 認 論 讀 誠 語 謝',
  },

  {
    id: 'structure-rule-12',
    category: 'structure',
    dynasty: 'modern',
    title: '12. 三聯法（品字結構）',
    source: '間架結構32法',
    description: '三個相同部件重疊者，要重心穩定，大小參差有致。',
    content: '森 淼 焱 磊 晶 品 鑫 蟲 矗 聶 疊 劦 尛',
  },

  {
    id: 'structure-rule-13',
    category: 'structure',
    dynasty: 'modern',
    title: '13. 左占法',
    source: '間架結構32法',
    description: '左大右小者，左部占據主位，右部避讓。',
    content: '敬 劉 助 即 歌 郭 郡 郊 郎 部 判 剛 劍',
  },

  {
    id: 'structure-rule-14',
    category: 'structure',
    dynasty: 'modern',
    title: '14. 右占法',
    source: '間架結構32法',
    description: '右大左小者，右部占據主位，左部讓位。',
    content: '施 秋 如 和 細 績 終 給 綠 約 級 紅 紐',
  },

  {
    id: 'structure-rule-15',
    category: 'structure',
    dynasty: 'modern',
    title: '15. 居中法',
    source: '間架結構32法',
    description: '上下結構或獨體字中，垂直中心線要端正居中。',
    content: '十 中 申 甲 平 千 半 市 華 畢 肅 申',
  },

  {
    id: 'structure-rule-16',
    category: 'structure',
    dynasty: 'modern',
    title: '16. 中寬法',
    source: '間架結構32法',
    description: '中間寬上下窄者，中腰橫畫或撇捺要舒展擴寬。',
    content: '喜 婁 無 意 愛 壽 曼 囊 帶 麥 索 委 旁',
  },

  {
    id: 'structure-rule-17',
    category: 'structure',
    dynasty: 'modern',
    title: '17. 中窄法',
    source: '間架結構32法',
    description: '中間窄上下寬者，中腰要緊收，上下要舒展。',
    content: '驚 攀 繁 鴦 鶩 響 警 譽 響 彎 變 戀 蠻',
  },

  {
    id: 'structure-rule-18',
    category: 'structure',
    dynasty: 'modern',
    title: '18. 上下鉤法',
    source: '間架結構32法',
    description: '字有上下鉤者，要前後呼應，筆勢連貫。',
    content: '水 小 糸 余 東 京 承 忝 泰 黎 染 梁',
  },

  {
    id: 'structure-rule-19',
    category: 'structure',
    dynasty: 'modern',
    title: '19. 左右佩法',
    source: '間架結構32法',
    description: '左右有對稱的撇捺或側筆，如同佩帶，要左右對稱。',
    content: '樂 繫 幾 辨 掰 瓣 辯 游 衍 銜 街 術',
  },

  {
    id: 'structure-rule-20',
    category: 'structure',
    dynasty: 'modern',
    title: '20. 偏無力法',
    source: '間架結構32法',
    description: '偏旁筆畫少而主體繁多時，偏旁要寫得挺拔有力。',
    content: '輝 糖 編 織 練 經 紀 終 繞 糾 絕 級',
  },

  {
    id: 'structure-rule-21',
    category: 'structure',
    dynasty: 'modern',
    title: '21. 孤單法',
    source: '間架結構32法',
    description: '字之孤單、筆畫極少者，線條宜稍粗重以顯豐滿。',
    content: '一 乙 二 三 十 口 日 月 小 川 山 天 之',
  },

  {
    id: 'structure-rule-22',
    category: 'structure',
    dynasty: 'modern',
    title: '22. 重併法',
    source: '間架結構32法',
    description: '相同的字重疊或並排出現，大小與筆法要有微妙變化。',
    content: '昌 林 羽 弱 朋 多 棘 喆 絲 赫 雙 兢 槑',
  },

  {
    id: 'structure-rule-23',
    category: 'structure',
    dynasty: 'modern',
    title: '23. 堆疊法',
    source: '間架結構32法',
    description: '筆畫繁多且密集堆疊者，要結構清晰，密中見疏。',
    content: '疊 齏 鬱 鑿 囊 爨 麤 龘 鸞 鸝 鬱 鑿 囊',
  },

  {
    id: 'structure-rule-24',
    category: 'structure',
    dynasty: 'modern',
    title: '24. 平正法',
    source: '間架結構32法',
    description: '字形結構看似傾斜，實則重心平正，斜中取正。',
    content: '多 名 勿 力 戈 乃 刀 歹 予 必 心 勿 也',
  },

  {
    id: 'structure-rule-25',
    category: 'structure',
    dynasty: 'modern',
    title: '25. 包圍法',
    source: '間架結構32法',
    description: '全包圍或半包圍結構，要四平八穩，內部空間均勻。',
    content: '國 園 圈 圍 區 巨 匡 匠 同 周 問 閃 閉',
  },

  {
    id: 'structure-rule-26',
    category: 'structure',
    dynasty: 'modern',
    title: '26. 覆蓋法',
    source: '間架結構32法',
    description: '上部覆蓋下部者，上方蓋畫要能安穩籠罩下部。',
    content: '宇 官 宮 空 家 寫 安 完 守 寄 密 富 寒',
  },

  {
    id: 'structure-rule-27',
    category: 'structure',
    dynasty: 'modern',
    title: '27. 承托法',
    source: '間架結構32法',
    description: '下部承托上部者，下部底畫要托載穩固，重心居中。',
    content: '孟 盛 盆 益 蓋 盤 鹽 監 盟 益 盈 盡 盎',
  },

  {
    id: 'structure-rule-28',
    category: 'structure',
    dynasty: 'modern',
    title: '28. 穿插法',
    source: '間架結構32法',
    description: '筆畫交錯穿插者，穿插點要準確，避讓得當。',
    content: '必 爽 脊 飛 無 爽 必 兆 兆 飛 夾 爽 脊',
  },

  {
    id: 'structure-rule-29',
    category: 'structure',
    dynasty: 'modern',
    title: '29. 垂曳法',
    source: '間架結構32法',
    description: '字有長撇或長捺向下垂曳舒展，筆勢要流暢放開。',
    content: '人 文 父 支 史 丈 更 吏 史 臾 皮 支 夫',
  },

  {
    id: 'structure-rule-30',
    category: 'structure',
    dynasty: 'modern',
    title: '30. 斜捺法',
    source: '間架結構32法',
    description: '字有主捺斜向右下伸展，捺腳收尾要沉穩而舒展。',
    content: '入 八 及 反 又 史 丈 夫 天 太 夫 交 支',
  },

  {
    id: 'structure-rule-31',
    category: 'structure',
    dynasty: 'modern',
    title: '31. 平捺法',
    source: '間架結構32法',
    description: '字底有平捺（如走之旁），平捺要波起浪伏，托載穩健。',
    content: '之 道 建 延 迎 超 這 進 迴 邊 送 達 連',
  },

  {
    id: 'structure-rule-32',
    category: 'structure',
    dynasty: 'modern',
    title: '32. 橫挑法',
    source: '間架結構32法',
    description: '字有橫畫或挑畫，要起伏有致，平正而有力度。',
    content: '七 也 毛 去 直 安 世 互 其 長 瓦 丰 韋',
  },

  {
    id: 'sutra-baiyi-zhou',
    category: 'sutra',
    dynasty: 'modern',
    title: '白衣大士神咒',
    source: '民間流傳經典',
    description: '極為普遍的觀音大士感應咒語，能救苦救難、消災解厄。',
    content: '南無大慈大悲救苦救難廣大靈感觀世音菩薩。南無大慈大悲救苦救難廣大靈感觀世音菩薩。南無大慈大悲救苦救難廣大靈感觀世音菩薩。南無佛。南無法。南無僧。南無救苦救難觀世音菩薩。怛垤哆。唵。伽囉伐哆。伽囉伐哆。伽訶伐哆。囉伽伐哆。囉伽伐哆。娑婆訶。天羅神。地羅神。人離難。難離身。一切災殃化為塵。南無摩訶般若波羅蜜。',
  },

  {
    id: 'sutra-jixiang-jing',
    category: 'sutra',
    dynasty: 'modern',
    title: '吉祥經',
    source: '巴利三藏經典',
    description: '南傳佛教經典，明列三十八種世間與出世間的最上吉祥修持。',
    content: '勿近愚癡人，應親近賢者，尊敬有德者，是為最吉祥。居住適宜處，往昔有德行，置身於正道，是為最吉祥。多聞工藝精，嚴持諸禁戒，言談悅人心，是為最吉祥。奉養父母親，愛護妻與子，從事無害業，是為最吉祥。布施好助人，幫助諸親眷，行為無瑕疵，是為最吉祥。邪行須禁止，克己不飲酒，美德堅不移，是為最吉祥。恭敬與謙讓，知足並感恩，及時聽教法，是為最吉祥。忍耐與順從，得見眾沙門，適時論信仰，是為最吉祥。自治淨梵行，領悟八正道，實證涅槃法，是為最吉祥。依世間八風，心毫不動搖，無憂無塵垢，是為最吉祥。依此行諸法，無往而不勝，隨處皆得福，是為最吉祥。',
  },

  {
    id: 'control-line-h',
    category: 'control',
    dynasty: 'modern',
    title: '基礎橫線練習',
    source: '控筆練習',
    description: '練習橫畫的平直、穩定度與控筆力度，注意起筆、行筆與收筆的停頓。',
    content: '一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一一',
  },

  {
    id: 'control-line-v',
    category: 'control',
    dynasty: 'modern',
    title: '基礎豎線練習',
    source: '控筆練習',
    description: '練習豎畫（懸針豎、垂露豎）的垂直度與手腕下行控筆的穩定度。',
    content: '丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨丨',
  },

  {
    id: 'control-slash-l',
    category: 'control',
    dynasty: 'modern',
    title: '基礎撇畫練習',
    source: '控筆練習',
    description: '練習向左下方撇出時的流暢度與出鋒收筆的控筆力量。',
    content: '丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿丿',
  },

  {
    id: 'control-slash-r',
    category: 'control',
    dynasty: 'modern',
    title: '基礎捺畫練習',
    source: '控筆練習',
    description: '練習向右下方斜畫行筆與出折（蠶頭雁尾）的按壓與提筆控制。',
    content: '乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀乀',
  },

  {
    id: 'control-dot',
    category: 'control',
    dynasty: 'modern',
    title: '基礎點畫練習',
    source: '控筆練習',
    description: '練習點畫（側點、撇點）的精確度與起收筆的按壓頓挫感。',
    content: '丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶丶',
  },

  {
    id: 'control-fold',
    category: 'control',
    dynasty: 'modern',
    title: '折角與折畫練習',
    source: '控筆練習',
    description: '練習橫折、折角的轉折頓挫，掌握折筆時蓄力與轉向的控筆要領。',
    content: '乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛乛',
  },

  {
    id: 'control-hook-v',
    category: 'control',
    dynasty: 'modern',
    title: '豎鉤練習',
    source: '控筆練習',
    description: '練習豎鉤、彎鉤的鉤出動作，注意出鉤前的頓筆與快速彈性挑出。',
    content: '亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅亅',
  },

  {
    id: 'control-hook-c',
    category: 'control',
    dynasty: 'modern',
    title: '彎鉤與浮鵝鉤練習',
    source: '控筆練習',
    description: '練習豎彎鉤（俗稱浮鵝鉤）的圓弧行筆與平穩向上出鉤的姿態。',
    content: '乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚乚',
  },

  {
    id: 'control-curve-s',
    category: 'control',
    dynasty: 'modern',
    title: '蛇形與S曲線控筆',
    source: '控筆練習',
    description: '練習連續彎曲行筆（如「乙」字）時，手指關節與手腕靈活度配合。',
    content: '乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙乙',
  },

  {
    id: 'control-intersect',
    category: 'control',
    dynasty: 'modern',
    title: '十字相交定位練習',
    source: '控筆練習',
    description: '練習橫豎畫相交的定位能力，注意十字中心點的結構對齊與筆畫比例。',
    content: '十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十十',
  },

  {
    id: 'control-star',
    category: 'control',
    dynasty: 'modern',
    title: '米字中心定位練習',
    source: '控筆練習',
    description: '利用「米」字練習多個不同方向筆畫交會於中心點時的空間定位。',
    content: '米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米米',
  },

  {
    id: 'control-square',
    category: 'control',
    dynasty: 'modern',
    title: '口字方框與對稱練習',
    source: '控筆練習',
    description: '練習正方形框架的外圍控筆，保證轉折處的封口完整性與左右對稱性。',
    content: '口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口口',
  },

  {
    id: 'control-circle',
    category: 'control',
    dynasty: 'modern',
    title: '圓轉弧線控筆練習',
    source: '控筆練習',
    description: '練習繪製正圓形、橢圓形或弧度時，手部肌肉的滑順過渡與速度控制。',
    content: '〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇〇',
  },

  {
    id: 'control-zigzag',
    category: 'control',
    dynasty: 'modern',
    title: '連續折線練習',
    source: '控筆練習',
    description: '練習連續折角與方向驟變時，手指發力與筆尖方向的快速切換。',
    content: 'ㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑㄑ',
  },
  {
    id: 'poem-xiaye',
    category: 'poem',
    dynasty: 'modern',
    title: '夏夜',
    source: '楊喚',
    description: '台灣國小現代詩。楊喚最膾炙人口的兒童詩，以純真與生動的擬人手法描繪夏夜的寧靜與生機。',
    content: '蝴蝶和蜜蜂們帶著花朵的蜜糖回來了，羊隊和牛群告別了田野回家了，火紅的太陽也滾著火輪子回家了，當街燈亮起來向村莊道過晚安，夏天的夜就輕輕地來了。來了！來了！從山坡上輕輕地爬下來了。來了！來了！從椰子樹梢上輕輕地爬下來了。撒了滿天的珍珠和一枚又大又亮的銀幣。美麗的夏夜呀！涼爽的夏夜呀！小雞和小鴨們關在欄裡睡了。聽完了老祖母的故事，小弟弟和小妹妹也闔上眼睛走向夢鄉了。（小妹妹夢見她變做蝴蝶在大花園裡忽東忽西地飛，小弟弟夢見他變做一條魚在藍色的大海裡游水。）睡了，都睡了！朦朧地，山巒靜靜地睡了！朦朧地，田野靜靜地睡了！只有窗外瓜架上的南瓜還醒著，伸長了藤蔓輕輕地往屋頂上爬。只有綠色的小河還醒著，低聲地歌唱著溜過彎彎的小橋。只有夜風還醒著，從竹林裡跑出來，跟著提燈的螢火蟲，在美麗的夏夜裡愉快地旅行。',
  },
  {
    id: 'poem-shuiguowanhui',
    category: 'poem',
    dynasty: 'modern',
    title: '水果們的晚會',
    source: '楊喚',
    description: '台灣國小現代詩。充滿奇幻童趣的名作，將水果擬人化，在月光下跳舞唱歌。',
    content: '窗外流動著寶石藍色的夜，屋子裡流進來牛乳一樣的月光，水果店裡的鐘噹噹地敲過了十二下，美麗的水果們就都一齊醒過來，請夜風指揮蟲兒們的樂隊來伴奏，這奇異的晚會就開了場。第一個是香蕉姑娘和鳳梨的高山舞，跳起來裙子就飄呀飄的那麼長；緊接著是龍眼先生們來翻筋斗，一起一落的劈啪響；西瓜和甘蔗可真滑稽，一隊胖來一隊瘦，怪模怪樣地演雙簧；芒果和楊桃只會笑，不停地喊好，不停地鼓掌。鬧呀笑呀的真高興，最後是全體水果們的大合唱，她們唱醒了沉睡著的夜，她們唱醒了沉睡著的雲彩，也唱來了美麗的早晨，唱出來了美麗的早晨的太陽。',
  },
  {
    id: 'poem-jia',
    category: 'poem',
    dynasty: 'modern',
    title: '家',
    source: '楊喚',
    description: '台灣國小現代詩。楊喚以溫柔的筆調，描寫自然界中各種生物溫馨的歸宿。',
    content: '樹葉是小毛蟲的搖籃，花朵是蝴蝶的眠床，歌唱的鳥兒誰都有一個舒適的巢。辛勤的螞蟻和蜜蜂都住著漂亮的大宿舍，螃蟹和小魚的家在藍色的小河裡。綠色無際的原野是蚱蜢和蜻蜓的家園。可憐的風沒有家，跑東跑西也找不到一個地方休息。飄流的雲沒有家，天一陰就急得不住地流眼淚。小弟弟和小妹妹最幸福哪！生下來就有媽媽爸爸給準備好了家，在家裡安安穩穩地長大。',
  },
  {
    id: 'poem-xiaomayi',
    category: 'poem',
    dynasty: 'modern',
    title: '小螞蟻',
    source: '楊喚',
    description: '台灣國小現代詩。簡短可愛的童詩，刻畫小螞蟻辛勤勞動與自然界互助的溫馨畫面。',
    content: '我們是一群不偷懶的小工人，搬不動哥哥的故事書，拉不走姐姐的花毛線，我們來抬小妹妹吃剩下的碎餅屑。下雨了，有小菌子給我們撐起了最漂亮的傘；過河了，有花瓣兒給我們搖來了最穩當的船。',
  },
  {
    id: 'poem-qicaihong',
    category: 'poem',
    dynasty: 'modern',
    title: '七彩的虹',
    source: '楊喚',
    description: '台灣國小現代詩。充滿想像力的童詩，將彩虹比作太陽國王送給能幹的小雨點的彩帶。',
    content: '接到了太陽國王的大掃除的命令，小雨點們就都坐上飛跑著的烏雲，賽跑著離開了天上的宮廷。他們給稻田和小河加足了水，他們給骯髒的山谷洗過了澡，就又來洗淨了清道夫永遠也掃不完的城市，也洗淨了悶熱的飛滿了塵土的天空。太陽國王為了獎賞他們真能幹，就送給他們一條美麗的長彩帶，那就是掛在明亮的雨後的天空中的紅、橙、黃、綠、藍、靛、紫的七彩的虹。',
  },
  {
    id: 'poem-chuntianzainali',
    category: 'poem',
    dynasty: 'modern',
    title: '春天在哪兒呀？',
    source: '楊喚',
    description: '台灣國小現代詩。楊喚以孩童的視角尋找春天，通過與自然及日常的對話傳遞春天的生氣。',
    content: '──春天來了！──春天在哪兒呀？小弟弟想了半天也搞不清；頂著南風放長了線，就請風箏去打聽。海鷗說：春天坐著船在海上旅行，難道你還沒有聽見水手們迎接春天的歌聲？燕子說：春天在天空裏休息，難道你還沒有看見忙來忙去的雲彩，仔細地把天空擦得那麼藍又那麼亮？麻雀說：春天在田野裏沿著小河散步，難道你還沒有看見大地從冬眠裏醒來，梳過了森林的頭髮，又給原野換上新裳？太陽說：春天在我的心裏燃燒，春天在花朵的臉上微笑，春天在學校裏跟著孩子們一道遊戲一道上課，春天在工廠裏伴著工人們一面工作又一面唱歌，春天穿過了每一條熱鬧的大街，春天也走進了每一條骯髒的小巷，輕輕地爬過了你鄰家的牆，也輕輕地走進了你的家。小弟弟說：春天住在我的家裏罷！我會把最好吃的糖果給它吃，媽媽會給它預備一張最舒服的小木床，等到打回大陸去，讓爸爸媽媽帶著我跟春天一起回家鄉。',
  },
  {
    id: 'poem-xiayule',
    category: 'poem',
    dynasty: 'modern',
    title: '下雨了',
    source: '楊喚',
    description: '台灣國小現代詩。以歡快活潑的節奏，描繪下雨時萬物的動態與童心之美。',
    content: '下雨了。太陽怕淋雨回家去休假。火車怕淋雨忙著開向車站。汽車和腳踏車還有老牛車也都忙著趕回家。可憐的是那高大的電線桿和綠色的郵筒，淋著雨站在街頭一動也不能動。花朵和樹木都低頭流淚. 小鴨和小鵝浸在泥水裡玩得最高興。麻雀躲在巢裡睡了覺。小妹妹怕聽那轟隆轟隆的雷聲，爬上床又蒙上被還捂緊了耳朵。迎著風雨，只有勇敢的海燕，不停地在海上向前飛行，飛行。',
  },
  {
    id: 'poem-xiaozhichuan',
    category: 'poem',
    dynasty: 'modern',
    title: '小紙船',
    source: '楊喚',
    description: '台灣國小現代詩。情境優美且富含想像力的童詩，寄託著孩子純真夢想與對自然的喜愛。',
    content: '你就快點摺起一個小紙船罷，別捨不得一張白色的勞作紙呀，再用你五彩的蠟筆畫上一個歪戴著白帽子的小水手。小蟋蟀是去參加一個音樂會，要過河去唱歌；小螞蟻忙了一天想媽媽，要過河趕回家。你看，你看他們都等急啦！當那太陽先生向白天告別的時候，當那雲彩小姐被吻得羞紅了臉，當那蝌蚪孩子要躲在河床下休息，就讓你的小紙船揚帆罷！讓它浮過小橋，讓它輕輕浮過小橋，可別驚醒了睡在小河上的晚霞。快點划！快點划！千萬叮嚀你的小水手別在半路上停了船哪！別讓他靠了岸去給他的小戀人採那開得金黃金黃的蒲公英花。你該知道，這時候，那熱鬧音樂會上已經響過一遍嘹喨的小喇叭，就是小螞蟻的媽媽也正焦急地等著他回去吃晚飯哪。等那月姐兒向小河照鏡子；等那星星們都頑皮地鑽出了頭，等那夜風和小草低語的時候，等那花朵都睡了，等那蟲兒都睡了的時候，螢火蟲也該提著燈籠來了，讓他們迎接你的小紙船和那忠實的小水手，平安地彎進那生遍蘆葦的靜靜的小港口！',
  },
  {
    id: 'poem-yanjing',
    category: 'poem',
    dynasty: 'modern',
    title: '眼睛',
    source: '楊喚',
    description: '台灣國小現代詩。透過不同動物的眼睛對比，引導孩子向明亮與美好的世界敞開心扉。',
    content: '小黑貓有兩隻黃色的大眼睛，在沒有月亮的晚上走路，那兩隻大眼睛就是牠的燈。小麻雀的眼睛最靈活，歡歡喜喜地飛起來，找著寂寞的孩子唱最快樂的歌給他聽。小老鼠的眼睛在夜裡才睜開，不敢走出來晒一晒太陽散一散步，永遠要守著一個又黑又濕的小土洞。媽媽的眼睛像太陽那樣溫暖，那樣亮，她微笑地看著你，她永遠地祝福你，因為常是她最心愛的寶貝兒。你的眼睛是窗子，要向著明亮的好太陽打開來呀！要向著藍色的天空打開來呀！要向著你要走的，也是最好的一條路打開來呀！別一看見書本就懶洋洋嚷：「喔！我的頭痛！」然後緊緊閉上，如像那闔上的蚌殼。',
  },
  {
    id: 'poem-feizaozhige',
    category: 'poem',
    dynasty: 'modern',
    title: '肥皂之歌',
    source: '楊喚',
    description: '台灣國小現代詩。以第一人稱視角描寫樸實肥皂的自白，讚美服務他人與帶來整潔的快樂。',
    content: '小朋友們，你們一定都會認識我，說我是一塊好肥皂。我不像那些穿得花花綠綠的香肥皂，被擺在大百貨店高貴的櫥窗裡，一生下來，我就被工人們裝進一個粗糙的大木箱。可是我很快樂，我也很驕傲。我願意幫助你們的媽媽辛苦地洗衣裳，我更願意跟著你們快活地吹泡泡。來，讓我們一起做一個好朋友吧！讓我每天替你們洗乾淨那又黑又髒的小手，再高興地看著你們穿著洗得又乾淨又潔亮的衣裳去上學校。',
  },
  {
    id: 'poem-laoya',
    category: 'poem',
    dynasty: 'modern',
    title: '老鴉',
    source: '胡適',
    description: '台灣國中現代詩。胡適白話新詩的代表作之一，以老鴉自喻，表達不媚俗、追求獨立的精神。',
    content: '我大清早起，站在人家屋角上，啞啞的啼。人家討嫌我，說我不吉利；——我不能呢呢喃喃，討人家的歡喜！天寒風緊，無枝可棲。我整日裏飛去飛回，整日裏又寒又飢。——我不能帶著鞘兒，翁翁央央的替人家飛；不能叫人家繫在竹竿頭，賺一把小米！',
  },
  {
    id: 'poem-hudie',
    category: 'poem',
    dynasty: 'modern',
    title: '蝴蝶',
    source: '胡適',
    description: '台灣國中現代詩. 中國現代文學史上第一首白話新詩，語言樸素，富含孤獨與自由的哲思。',
    content: '兩個黃蝴蝶，雙雙飛上天。不知為什麼，一個忽飛還。剩下那一個，孤單怪可憐。也無心上天，天上太孤單。',
  },
  {
    id: 'poem-hushang',
    category: 'poem',
    dynasty: 'modern',
    title: '湖上',
    source: '胡適',
    description: '台灣國中現代詩。極為簡練雋永的短詩，以水面螢火的重合寓意知音的相遇。',
    content: '水上一個螢火，水裏一個螢火，平排著，輕輕地，打我們的船邊飛過。他們倆兒越飛越近，漸漸地並作了一個。',
  },
  {
    id: 'poem-wobuzhidaofeng',
    category: 'poem',
    dynasty: 'modern',
    title: '我不知道風是在那一個方向吹',
    source: '徐志摩',
    description: '台灣國中現代詩。徐志摩極具音樂美感的經典抒情詩，在夢境與迷惘中展現情感的起伏。',
    content: '我不知道風是在那一個方向吹——我是在夢中，在夢的輕波裏依洄。我不知道風是在那一個方向吹——我是在夢中，她的溫存，我的迷醉。我不知道風是在那一個方向吹——我是在夢中，甜美是夢裏的光輝。我不知道風是在那一個方向吹——我是在夢中，她的負心，我的傷悲。我不知道風是在那一個方向吹——我是在夢中，在夢的悲哀裏心碎！我不知道風是在那一個方向吹——我是在夢中，黯淡是夢裏的光輝。',
  },
  {
    id: 'poem-siyu',
    category: 'poem',
    dynasty: 'modern',
    title: '私語',
    source: '徐志摩',
    description: '台灣國中現代詩。意境冷清而繾綣的抒情詩，將秋天雨柳的細碎聲音化為心中私語。',
    content: '秋雨在一流清冷的秋水池，一棵憔悴的秋柳裏，一條怯憐的秋枝上，一片將黃未黃的秋葉上，聽他親親切切喁喁唼唼，私語三秋的情思情事，情語情節，臨了輕輕將他拂落在秋水秋波的秋暈裏，一渦半轉，跟著秋流去。這秋的私語，秋的情思情事，情語情節，已掉落在秋水秋波的秋暈裏，一渦半轉，跟著秋水流去。',
  },
  {
    id: 'poem-fanyou',
    category: 'poem',
    dynasty: 'modern',
    title: '煩憂',
    source: '戴望舒',
    description: '台灣國中現代詩。戴望舒膾炙人口的抒情短詩，結構迴環往復，流露淡淡的憂鬱與相思。',
    content: '說是寂寞的秋的清愁，說是遼遠的海的相思。假如有人問我的煩憂，我不敢說出你的名字。我不敢說出你的名字，假如有人問我的煩憂：說是遼遠的海的相思，說是寂寞的秋的清愁。',
  },
  {
    id: 'poem-xunmengzhe',
    category: 'poem',
    dynasty: 'modern',
    title: '尋夢者',
    source: '戴望舒',
    description: '台灣國中現代詩。戴望舒極具象徵色彩的佳作，以金色貝殼與桃色珍珠寄託對夢想與理想的執著追求。',
    content: '夢會開出花來的，夢會開出嬌妍的花來的：去求無價的珍寶吧。在青色的大海里，在青色的大海的底里，深藏着金色的貝一枚。你去攀九年的冰山吧，你去航九年的旱海吧，然後你逢到那金色的貝。它有天上的雲雨聲，它有海上的風濤聲，它會使你的心沉醉。把它在海水裡養九年，把它在天水裡養九年，然後，它在一個暗夜裡開綻了。當你鬢髮斑斑了的時候，當你眼睛朦朧了的時候，金色的貝吐出桃色的珠。把桃色的珠放在你懷裡，把桃色的珠放在你枕邊，於是，一個夢靜靜地升上來了。你的夢開出花來了，你的夢開出嬌妍的花來了，在你已衰老了的時候。',
  },
  {
    id: 'poem-shenyeleyuesheng',
    category: 'poem',
    dynasty: 'modern',
    title: '深夜裡聽到樂聲',
    source: '林徽因',
    description: '台灣國中現代詩。林徽因溫婉精緻的抒情詩，在深夜的琴聲中抒發對生命的無奈與憧憬。',
    content: '這一定又是你的手指，輕彈著，在這深夜，稠密的悲思；我不禁頰邊泛上了紅，靜聽著，這深夜裡弦子的生動。一聲聽從我心底穿過，忒淒涼，我懂得，但我怎能應和？生命早描定她的式樣，太薄弱，是人們的美麗的想象。除非在夢裡有這麼一天，你和我，同來攀動那根希望的弦。',
  },
  {
    id: 'poem-liandeng',
    category: 'poem',
    dynasty: 'modern',
    title: '蓮燈',
    source: '林徽因',
    description: '台灣國中現代詩。林徽因寓意深遠的哲理詩，以蓮燈自許，展現對生命尊嚴與個人光芒的執著。',
    content: '如果我的心是一朵蓮花，正中擎出一支點亮的蠟，熒熒雖則單是那一剪光，我也要它驕傲的捧出輝煌。不怕它只是我個人的蓮燈，照不見前後崎嶇的人生——浮沉它依附着人海的浪濤，明暗自成了它內心的秘奧。單是那光一閃花一朵——像一葉輕舸駛出了江河——宛轉它漂隨命運的波涌，等候那陣陣風向遠處推送。算做一次過客在宇宙裡，認識這玲瓏的生從容的死，這飄忽的途程也就是個——也就是個美麗美麗的夢。',
  },
  {
    id: 'poem-zhuiqiu',
    category: 'poem',
    dynasty: 'modern',
    title: '追求',
    source: '覃子豪',
    description: '台灣國中現代詩。覃子豪激昂悲壯的抒情詩，以落日與駿馬象徵不懈追求理想的健偉靈魂。',
    content: '大海中的落日，悲壯得像英雄的感嘆，一顆心追過去，向遙遠的天邊。黑夜的海風，颳起了黃沙，在蒼茫的夜裏，一個健偉的靈魂，跨上了時間的駿馬。',
  },
  {
    id: 'poem-yexu',
    category: 'poem',
    dynasty: 'modern',
    title: '也許',
    source: '聞一多',
    description: '台灣高中現代詩。聞一多為夭折長女寫的葬歌，結構嚴記，充滿哀傷而克制的父愛，富於音樂美。',
    content: '也許你真是哭得太累，也許，也許你要睡一睡，那麼叫夜鷹不要咳嗽，蛙不要號，蝙蝠不要飛；不許陽光撥你的眼簾，不許清風刷上你的眉，無論誰都不能驚醒你，撐一傘松蔭庇護你睡；也許你聽這蚯蚓翻泥，聽這小草的根鬚吸水，也許你聽這般的音樂，比那咒罵的人聲更美；那麼你先把眼皮閉緊，我就讓你睡，我讓你睡，我把黃土輕輕蓋著你，我叫紙錢兒緩緩的飛。',
  },
  {
    id: 'poem-secai',
    category: 'poem',
    dynasty: 'modern',
    title: '色彩',
    source: '聞一多',
    description: '台灣高中現代詩。聞一多實踐「三美」理論的佳作，以多種色彩賦予生命以豐富的情感與哲理。',
    content: '生命是張沒價值的白紙，自從綠給了我發展，紅給了我情熱，黃教我以忠義，藍教我以高潔，粉紅賜我以希望，灰白贈我以悲哀；再完成這幀彩圖，黑還要加我以死。從此以後，我便溺愛於我的生命，因為我愛他的色彩。',
  },
  {
    id: 'poem-hongzhu',
    category: 'poem',
    dynasty: 'modern',
    title: '紅燭',
    source: '聞一多',
    description: '台灣高中現代詩。聞一多處女詩集的序詩，以紅燭的燃燒與流淚隱喻詩人奉獻生命追求光明的決心。',
    content: '紅燭啊！這樣紅的燭！詩人啊！吐出你的心來比比，可是一般顏色？紅燭啊！是誰製的蠟——給你軀體？是誰點的火——點著靈魂？為何更須燒蠟成灰，然後才放光出？一誤再誤；矛盾！衝突！紅燭啊！不誤，不誤！原是要「燒」出你的光來——這正是自然的方法。紅燭啊！既製了，便燒著！燒罷！燒罷！燒破世人的夢，燒沸世人的血——也救出他們的靈魂，也搗破他們的監獄！紅燭啊！你心火發光之期，正是淚流開始之日。紅燭啊！匠人造了你，原是為燒的。既已燒著，又何苦傷心流淚？哦！我知道了！是殘風來侵你的光芒，你燒得不穩時，才急著得流淚！紅燭啊！流罷！你怎能不流呢？請將你的脂膏，不息地流向人間，培出慰藉的花兒，結成快樂的果子！紅燭啊！你流一滴淚，灰一分心。灰心流淚你的果，創造光明你的因。紅燭啊！「莫問收穫，但問耕耘。」',
  },
  {
    id: 'poem-woyongcansun',
    category: 'poem',
    dynasty: 'modern',
    title: '我用殘損的手掌',
    source: '戴望舒',
    description: '台灣高中現代詩。戴望舒在獄中創作的愛國名篇，以殘損手掌撫摸地圖，寄託對土地的深情與希望。',
    content: '我用殘損的手掌摸索這廣大的土地：這一角已變成灰燼，那一角祇是血和泥；這一片湖該是我的家鄉，（春天，堤上繁花如錦障，嫩柳枝折斷有奇異的芬芳）我觸到荇藻和水的微涼；這長白山的雪峯冷到徹骨，這黃河的水夾泥沙在指間滑出；江南的水田，你當年新生的禾草是那麼細，那麼輭……現在祇有蓬蒿；嶺南的荔枝花寂寞地憔悴，儘那邊，我蘸著南海沒有漁船的苦水……無形的手掌掠過無限的江山，手指沾了血和灰，手掌黏了陰暗，祇有那遼遠的一角依然完整，溫暖，明朗，堅固而蓬勃生春。在那上面，我用殘損的手掌輕撫，像戀人的柔髮，嬰孩手中乳。我把全部的力量運在手掌貼在上面，寄與愛和一切希望，因爲祇有那裏是太陽，是春，將驅逐陰暗，帶來甦生，因爲祇有那裏我們不像牲口一樣活，螻蟻一樣死……那裏，永恆的中國！',
  },
  {
    id: 'poem-pingzhicunzai',
    category: 'poem',
    dynasty: 'modern',
    title: '瓶之存在',
    source: '覃子豪',
    description: '台灣高中現代詩。覃子豪中後期具有現代主義與超現實主義色彩的代表作，探討美與永恆的存在。',
    content: '淨化官能的熱情、昇華為零，而靈於感應吸納萬有的呼吸與音籟在體中，化為律動自在自如的挺圓圓的腹。挺圓圓的腹似坐著，又似立著：禪禪寂然的靜坐，佛之莊嚴的肅立；似背著，又似面著：背深淵而面虛無，背虛無而臨深淵。無所不背，君臨於無視；無所不面，面面的靜觀。不是平面，是一立體；不是四方，而是圓，照應萬方。圓通的感應，圓通的能見度。是一軸心，具有引力與光的輻射，挺圓圓的腹。清醒於假寐，假寐於清醒。自我的靜中之動，無我的無功無靜。存在於肯定中，亦存在於否定中。不是偶然，沒有眉目；不是神祇，沒有教義。是一存在，靜止的存在，美的存在。而美形於意象，可見可感而不可確定的意象，是另一世界之存在。是古典、象徵、立體、超現實與抽象所混合的秩序，夢的秩序。誕生於造物者感興的設計，顯示於混沌而清明，抽象而具象的形體，存在於思維的赤裸與明晰。假寐七日，醒一千年；假寐千年，聚萬年的冥想。化渾噩為靈明，化清晰為朦朧。群星與太陽在宇宙的大氣中，典雅，古朴如昔，光煥，新鮮如昔；靜止如之，澄明如之，渾然如之。每一寸都是光，每一寸都是美，無需假借，無需裝飾。繁星森然閃爍於夜晚，隱藏於白晝；無一物存在的白晝太陽是其主宰。青空渺渺，深邃而有不可窮究的富饒。深藏空靈在你腹中，是不可窮究的虛無。蛹的蛻變，花的繁開與謝落，蝶展翅，向日葵揮灑種子。演進、嬗遞、循環無盡？或如笑聲之迸發與逝去，是一個刹那？刹那接連刹那，日出日落，時間在變，而時間依然。你握時間的整體，容一宇宙的寂寞，在永恒的靜止中，吐納虛無. 自適如一，自如如一，自在如一，而定於一。寓定一於孤獨的變化中，不容分割，無可腐朽。——徹悟之後的靜止——大覺之後的存在。自在自如的挺圓圓的腹。宇宙包容你，你腹中卻孕育著一個宇宙，宇宙因你而存在。',
  },
  {
    id: 'poem-yuexialeifeng',
    category: 'poem',
    dynasty: 'modern',
    title: '月下雷峰影片',
    source: '徐志摩',
    description: '台灣高中現代詩。徐志摩融合中西藝術之美的經典之作，描摹西湖黑白明暗的倒影與朦朧夢境。',
    content: '我送你一個雷峰塔影，滿天稠密的黑雲與白雲；我送你一個雷峰塔頂，明月瀉影在眠熟的波心。深深的黑夜，依依的塔影，團團的月彩，纖纖的波鱗——假如你我蕩一支無遮的小艇，假如你我創一個完全的夢境！',
  },
  {
    id: 'poem-canchun',
    category: 'poem',
    dynasty: 'modern',
    title: '殘春',
    source: '徐志摩',
    description: '台灣高中現代詩。徐志摩感嘆青春易逝與生命無常的短詩，以瓶中桃花的凋謝隱喻殘春命運。',
    content: '昨天我瓶子裏斜插著的桃花，是朵朵媚笑在美人的腮邊掛；今兒它們全低了頭，全變了相：——紅的白的屍體倒懸在青條上。窗外的風雨報告殘春的運命，喪鐘似的音響在黑夜裏叮嚀：「你那生命的瓶子裏的鮮花也變了樣：艷麗的屍體，誰給收殮？」',
  },
  {
    id: 'poem-huangli',
    category: 'poem',
    dynasty: 'modern',
    title: '黃鸝',
    source: '徐志摩',
    description: '台灣高中現代詩。徐志摩簡練空靈的短詩，捕捉黃鸝飛入與展翅離去的瞬間，讚美生命中純粹的熱情。',
    content: '一掠顏色飛上了樹。「看，一隻黃鸝！」有人說。翹著尾尖，它不作聲，艷異照亮了濃密——像是春光，火焰，像是熱情。等候它唱，我們靜著望，怕驚了它。但它一展翅，衝破濃密，化一朵彩雲；它飛了，不見了，沒了——像是春光，火焰，像是熱情。',
  },
  {
    id: 'poem-xiao',
    category: 'poem',
    dynasty: 'modern',
    title: '笑',
    source: '林徽因',
    description: '台灣高中現代詩。林徽因極富音樂性與畫面感的抒情短詩，描摹女子笑容中的純真、靈動與美好。',
    content: '笑的是她的眼睛，口唇，和唇邊渾圓的漩渦。艷麗如同露珠，朵朵的笑向貝齒的閃光裡躲。那是笑——神的笑，美的笑：水的映影，風的輕歌。笑的是她惺忪的鬈髮，散亂的挨著她的耳朵。輕軟如同花影，癢癢的甜蜜湧進了你的心窩。那是笑——詩的笑，畫的笑：雲的留痕，浪的柔波。',
  },
  {
    id: 'poem-gesheng',
    category: 'poem',
    dynasty: 'modern',
    title: '歌聲',
    source: '朱自清',
    description: '台灣高中現代詩。朱自清流傳甚廣的抒情短詩，寫歌聲給內心帶來的平靜，忘卻物我，極具感染力。',
    content: '好嘹亮的歌聲！黑暗的空地里，仿佛充滿了光明。我波瀾洶湧的心，像古井般平靜；可是一些沒冷，還深深地含著縷縷微溫。甚麼世界？甚麼我和人？我全忘記了，——一些不省！',
  },

  {
    id: 'lyrics-diudiutang',
    category: 'lyrics',
    dynasty: 'modern',
    title: '丟丟銅仔',
    source: '宜蘭民謠',
    description: '台灣公版歌謠。經典宜蘭傳統民謠，以模擬火車行經鐵路及水滴落聲的虛字為特色，節奏活潑輕快，極適合硬筆書寫練習。',
    content: '火車行到伊都，阿末伊都丟，哎呀伊都丟哎唷，火車箱伊都丟，水滴伊都丟伊都，丟丟銅仔伊都，阿末伊都，丟。雙腳踏到伊都，阿末伊都丟，哎呀伊都丟哎唷，穿過山洞伊都丟，水滴伊都丟伊都，丟丟銅仔伊都，阿末伊都，丟。',
  },
  {
    id: 'lyrics-thinn-oo-oo',
    category: 'lyrics',
    dynasty: 'modern',
    title: '天黑黑',
    source: '台灣北部民謠',
    description: '台灣公版歌謠。著名北台灣傳統民謠，描寫阿公阿嬤因為煮鹹煮淡而吵架的有趣生活場景，童趣十足，字句簡練流暢。',
    content: '天黑黑，要落雨，阿公仔舉鋤頭要掘芋。掘啊掘，掘啊掘，掘著一尾旋鰡鼓，咿呀嘿嘟真正趣味。阿公仔要煮鹹，阿嬤仔要煮淡，倆個相打弄破鼎，咿呀嘿嘟弄破鼎，弄破鼎。',
  },
  {
    id: 'lyrics-langkekang',
    category: 'lyrics',
    dynasty: 'modern',
    title: '草螟弄雞公',
    source: '台灣南部民謠',
    description: '台灣公版歌謠。經典恆春/南部傳統民謠，以「草螟弄雞公」比喻老夫少妻的逗趣互動，韻律感強烈，字體結構多變。',
    content: '草螟弄雞公，雞公啵啵跳。草螟弄雞公，雞公啵啵跳。少年若是娶老嬤，每日就親像草螟弄雞公。雞公啵啵跳，草螟弄雞公，雞公啵啵跳。老歲人娶嬌妻，每日親像草螟弄雞公。雞公啵啵跳，草螟弄雞公，雞公啵啵跳。',
  },
  {
    id: 'lyrics-liokguemuali',
    category: 'lyrics',
    dynasty: 'modern',
    title: '六月茉莉',
    source: '台灣傳統民謠',
    description: '台灣公版歌謠。南部傳統歌謠，以六月茉莉的芬芳與花落寄託單身女子對良人與美好生活的期盼，婉約柔美。',
    content: '六月茉莉真正香，單身娘子守空房。有心栽培花袂放，無情風雨一直送。六月茉莉香透天，單身娘子無人憐。望得好花開滿枝，望得良人早團圓。',
  },
  {
    id: 'lyrics-sai-pak-hoo',
    category: 'lyrics',
    dynasty: 'modern',
    title: '西北雨直直落',
    source: '台灣傳統民謠',
    description: '台灣公版歌謠。描寫西北雨中動物迎娶新娘的趣味傳統童謠，節奏明快，文字具象生動，適合行筆流暢練習。',
    content: '西北雨直直落，鯽仔魚要娶妻。鮕鮐愚打鑼鼓，媒人婆土虱嫂。日頭暗尋無路，趕緊來火金姑，做好照路，走去娶新娘。西北雨直直落，白鷺鷥來照路。送新娘要過河，水打倒土虱嫂。日頭暗尋無路，趕緊來火金姑，做好照路，走去娶新娘。',
  },
  {
    id: 'lyrics-tsiahao',
    category: 'lyrics',
    dynasty: 'modern',
    title: '一隻鳥仔哮啾啾',
    source: '嘉義民謠',
    description: '台灣公版歌謠。經典嘉義傳統民謠，描寫一隻鳥兒在黃昏啼哭的孤寂，旋律悲涼而優美，情感深沉內斂。',
    content: '嘿嘿嘿，一隻鳥仔哮啾啾，哮到三更半夜哭哀哀，引我心酸引我悲，啊呀喂，我的心肝焦。嘿嘿嘿，一隻鳥仔哮啾啾，哮到黃昏日落哭哀哀，不知巢在何處安，啊呀喂，我的心肝焦。',
  },
  {
    id: 'lyrics-pehloosian',
    category: 'lyrics',
    dynasty: 'modern',
    title: '白鷺鷥',
    source: '台灣傳統童謠',
    description: '台灣公版歌謠。人人耳熟能詳的台灣閩南語傳統童謠，字句簡短，富含生活趣味，是硬筆抄寫的經典入門篇章。',
    content: '白鷺鷥，車畚箕，車到溝仔墘。跌一倒，拾到一仙錢。錢拿去買餅乾，吃得飽嘟嘟，回去被阿母打得大聲哭。',
  },
  {
    id: 'lyrics-siutsai',
    category: 'lyrics',
    dynasty: 'modern',
    title: '秀才騎馬弄弄來',
    source: '台灣傳統童謠',
    description: '台灣公版歌謠。連鎖調結構的傳統童謠，以買雜貨的趣味文字環環相扣，字字珠圓玉潤，適合日常硬筆臨摹。',
    content: '秀才騎馬弄弄來，走路走到府城街。府城街，買胡椒，胡椒甜，買金針，金針苦，買豆腐，豆腐白，買茄子，茄子青，買鯉魚，鯉魚紅。弄弄來，弄弄去，弄到秀才坐飛機。',
  },
  {
    id: 'lyrics-gulekua',
    category: 'lyrics',
    dynasty: 'modern',
    title: '牛犁歌',
    source: '台灣傳統民謠',
    description: '台灣公版歌謠。經典農村勞動民謠，描寫水牛耕田的田園景致與豐收盼望，節奏歡快，筆畫蒼勁有力。',
    content: '東爿日出金爍爍，水牛牽出走向田。犁頭拖到水田邊，腳踏泥土心歡喜。咿呀嘿，咿呀嘿，大家協力來犁田。南風吹來稻花香，汗水滴落土出金。不怕辛苦不怕累，只盼秋來大豐收。咿呀嘿，咿呀嘿，耕耘才有好收成。',
  },
  {
    id: 'lyrics-siangsiongkhi',
    category: 'lyrics',
    dynasty: 'modern',
    title: '思想起',
    source: '恆春民謠',
    description: '台灣公版歌謠。最著名的恆春民謠，歎唱墾荒歲月與先祖渡海來台的艱辛，文字悠揚，字裡行間極具歷史溫度。',
    content: '思啊想起，恆春半島好風光，四面環海日頭長。墾丁落山風吹來，椰子樹影搖晃晃。思啊想起，祖先過海來台灣，千辛萬苦建家園。不怕風雨不怕難，代代相傳到永遠。',
  },
  {
    id: 'lyrics-usuanntiau',
    category: 'lyrics',
    dynasty: 'modern',
    title: '雨傘調',
    source: '台灣傳統民謠',
    description: '台灣公版歌謠。流傳甚廣的台灣傳統民謠，以雨中攜手行走的意象隱喻同行風雨的真摯情感，結構整齊對稱。',
    content: '雨傘開花對面看，手牽伴侶走向前。天空落雨免驚惶，有傘遮雨心溫暖。路途遙遠相扶持，風雨同行情意深。雨傘開花對面看，手牽伴侶走向前。',
  },
  {
    id: 'lyrics-thoohuekuetoo',
    category: 'lyrics',
    dynasty: 'modern',
    title: '桃花過渡',
    source: '台灣傳統民謠',
    description: '台灣公版歌謠。流傳於歌仔戲及民間的車鼓小調，描寫桃花姑娘過渡時與船伯的風趣互動，節奏極具動感。',
    content: '正月人迎花燈，桃花出嫁要過渡。撐船阿伯笑哈哈，問妳要過哪條河。咿呀嘿，咿呀嘿，桃花過渡笑哈哈。二月桃花開滿枝，撐船過河好時機。水波蕩漾人歡喜，風吹花落人更美。咿呀嘿，咿呀嘿，桃花過渡笑哈哈。',
  },
  {
    id: 'lyrics-gehkngkng',
    category: 'lyrics',
    dynasty: 'modern',
    title: '月光光',
    source: '客家傳統童謠',
    description: '台灣公版歌謠。經典客家傳統童謠，歌詞如詩般悠美，層層遞進，讀來朗朗上口，是體驗客家語言與文字之美的佳作。',
    content: '月光光，秀才郎，騎白馬，過蓮塘。蓮塘背，種韭菜，韭菜花，結親家。親家門前一樹梅，三夜開花兩夜落。拾得梅子拿去賣，賣得銀錢娶媳婦。',
  },
  {
    id: 'lyrics-loksui-thien',
    category: 'lyrics',
    dynasty: 'modern',
    title: '落水天',
    source: '客家傳統民謠',
    description: '台灣公版歌謠。極具代表性的客家傳統民謠，描述雨天無傘行走的無奈，意境淒美純樸，字句簡約易寫。',
    content: '落水天，落水天，無傘子，我真可憐。衣裳濕，鞋子破，走到半路無處躲。落水天，落水天，只盼雨過見晴天。日頭出，風吹乾，抹乾淚水笑開顏。',
  },
  {
    id: 'lyrics-thienkung-loksui',
    category: 'lyrics',
    dynasty: 'modern',
    title: '天公落水',
    source: '客家傳統民謠',
    description: '台灣公版歌謠。流傳極廣的客家民謠，描寫山歌對唱與田園風光，展現客家兒女勤勞與樂觀的性格。',
    content: '天公落水喲，阿妹戴著草帽戴著草帽撐把傘。走到水田邊，腳踩泥土腳踩泥土心歡喜。阿哥走過來，問聲阿妹要去哪。手牽手，肩並肩，大家協力建家園。',
  },
  {
    id: 'lyrics-buyugua',
    category: 'lyrics',
    dynasty: 'modern',
    title: '捕魚歌',
    source: '台灣民謠',
    description: '台灣公版歌謠。台灣經典民間歌謠（源於阿美族傳統旋律），描寫漁民與風浪搏鬥並滿載而歸的奮鬥精神。',
    content: '白浪滔滔我不怕，撐起舵兒往前劃。撒網下水把魚捕，捕得大魚笑哈哈。不怕風，不怕浪，我們是勇敢的捕魚郎。大家努力齊劃槳，滿載而歸喜洋洋。',
  },
  {
    id: 'lyrics-taohuadiqixue',
    category: 'lyrics',
    dynasty: 'modern',
    title: '桃花泣血記',
    source: '詹天馬',
    description: '台灣公版歌謠。1932年同名宣傳電影主題曲，詹天馬作詞（詹天馬1953年逝世，著作權已屆滿），宣導文明新時代的自由戀愛。',
    content: '人生制度最繁雜，束縛姑娘袂自由，悲劇發生無帶念，逼到絕路死才休。文明社會新時代，自由戀愛才應該，父母無權來阻礙，配婚制度要打碎。桃花姑娘真可憐，愛人無緣難團圓，情深意重如磐石，誓死不屈到百年。',
  },
  {
    id: 'lyrics-siobahtsang',
    category: 'lyrics',
    dynasty: 'modern',
    title: '燒肉粽',
    source: '張邱東松',
    description: '台灣公版歌謠。作詞者張邱東松於1959年逝世（著作權已屆滿），刻畫戰後台灣底層民眾生活的艱辛，字字寫實感人。',
    content: '自悲自嘆歹命人，父母物資無半項。欲做生意無本錢，辦分期付無人信。只好來賣燒肉粽。燒肉粽，燒肉粽，賣燒肉粽。做人生意真難做，擔子提著沿街叫。不畏風寒與烈日，只求一日能吃飽。燒肉粽，燒肉粽，賣燒肉粽。',
  },
  {
    id: 'lyrics-siutsiukan',
    category: 'lyrics',
    dynasty: 'modern',
    title: '收酒矸',
    source: '張邱東松',
    description: '台灣公版歌謠。作詞者張邱東松於1959年逝世（著作權已屆滿），生動寫實地刻畫早期拾荒者的辛苦與堅韌，適合硬筆書寫。',
    content: '有酒矸，倘賣無？有破銅爛鐵，倘賣無？挑著擔子走四方，沿街叫賣收酒矸。雖然辛苦無怨言，只求一日能吃飽。有酒矸，倘賣無？有破銅爛鐵，倘賣無？',
  },
  {
    id: 'lyrics-iauina',
    category: 'lyrics',
    dynasty: 'modern',
    title: '搖嬰仔歌',
    source: '盧雲生',
    description: '台灣公版歌謠。由盧雲生作詞（盧雲生於1968年逝世，著作權已屆滿），是台灣最著名的閩南語搖籃曲，流露母愛的溫暖。',
    content: '嬰仔嬰嬰困，一瞑大一寸。嬰仔嬰嬰惜，一瞑大一尺。搖兒到大漢，做個好兒郎。孝順父母親，報答養育恩。嬰仔嬰嬰困，一瞑大一寸。',
  },

  // --- 周夢蝶 (補齊 5 首) ---
  {
    id: 'poem-zhoumengdie-chana',
    category: 'poem',
    dynasty: 'modern',
    title: '剎那',
    source: '周夢蝶',
    description: '周夢蝶富含禪宗哲理的名作，以凝鍊字句思索時間與永恆。',
    content: '當你為我拭去第一滴眼淚，第一顆星就在天邊升起了。此時此刻，微風不起，江水無波，而所有的花朵都在靜默中綻放。一剎那就是一生，一生只在這一剎那。',
  },
  {
    id: 'poem-zhoumengdie-baidu',
    category: 'poem',
    dynasty: 'modern',
    title: '擺渡表',
    source: '周夢蝶',
    description: '周夢蝶代表性哲思詩篇，寫生命的渡化與追尋。',
    content: '只要拂塵一掃，便有千江明月。而你總是不慌不忙地撐著長篙，從彼岸渡向此岸，又從此岸渡回彼岸。問你渡的是誰？你笑了笑，指著水中的倒影：不過是渡那未醒的夢人。',
  },
  {
    id: 'poem-zhoumengdie-shijian',
    category: 'poem',
    dynasty: 'modern',
    title: '給時間',
    source: '周夢蝶',
    description: '周夢蝶探索歲月與心靈境地的經典小品。',
    content: '留一盞燈給夜，留一朵雲給天空，留一段沉默給歲月。當一切喧囂歸於平靜，時間便化作一滴清澈的露珠，靜靜躺在荷葉的掌心。',
  },

  // --- 瘂弦 (補齊 5 首) ---
  {
    id: 'poem-yaxian-hongyumi',
    category: 'poem',
    dynasty: 'modern',
    title: '紅玉米',
    source: '瘂弦',
    description: '瘂弦深情懷鄉的名篇，富含鄉土色彩與記憶的溫度。',
    content: '宣統那年的風吹著，吹著那串紅玉米。它掛在簷下，像一盞長久未熄的燈籠，靜靜守著老屋的黃昏與童年的故事。',
  },
  {
    id: 'poem-yaxian-qiuge',
    category: 'poem',
    dynasty: 'modern',
    title: '秋歌',
    source: '瘂弦',
    description: '瘂弦極具抒情美感與音樂節奏的秋日詠嘆調。',
    content: '落葉落葉，秋天來了。小草黃了，樹葉紅了。你若是來，請踏著軟軟的泥土，聽那落葉在腳下輕輕地低語。',
  },
  {
    id: 'poem-yaxian-shenyuan',
    category: 'poem',
    dynasty: 'modern',
    title: '深淵（節選）',
    source: '瘂弦',
    description: '瘂弦現代主義代表作，深沉反思現代人的生存境況。',
    content: '我要在懸崖的邊緣種一朵花，讓它在風中搖曳，看著深淵，也讓深淵看著它。生活是一場無休止的追尋，在光明與黑暗交界的微光裡，我們繼續前行。',
  },

  // --- 洛夫 (補齊 5 首) ---
  {
    id: 'poem-luofu-yanzhiwai',
    category: 'poem',
    dynasty: 'modern',
    title: '煙之外',
    source: '洛夫',
    description: '洛夫抒情代表作，意境空靈悠遠，語言凝鍊。',
    content: '在煙之外，有一種更淡的煙；在山之外，有一種更高的山。當你轉身離去，天地突然安靜得只剩下風聲與我的心跳。',
  },
  {
    id: 'poem-luofu-shishi',
    category: 'poem',
    dynasty: 'modern',
    title: '石室之死亡（節選）',
    source: '洛夫',
    description: '洛夫震撼詩壇的超現實史詩級經典，充滿驚人的意象張力。',
    content: '只偶然昂首向鄰居的雨季，止於驟雨的午後。我是那座被雷電擊中依然挺立的石室，在風雨與時間的淬鍊中，守護著永恆的火種。',
  },

  // --- 紀弦 (補齊 5 首) ---
  {
    id: 'poem-jixian-huaishuye',
    category: 'poem',
    dynasty: 'modern',
    title: '一片槐樹葉',
    source: '紀弦',
    description: '紀弦傳誦極廣的抒情名篇，以一片槐樹葉寄託悠悠鄉思。',
    content: '這是一片槐樹葉，夾在我的筆記本裡。薄薄的，乾乾的，泛著淡淡的黃色。每當我輕輕撫摸它，就想起了故鄉那條長滿槐樹的古老街道。',
  },
  {
    id: 'poem-jixian-nidemingzi',
    category: 'poem',
    dynasty: 'modern',
    title: '你的名字',
    source: '紀弦',
    description: '紀弦極簡而深情的愛情短詩。',
    content: '用了世界上最輕的聲音，呼喚你的名字。如同一片花瓣飄落水面，激起一圈又一圈，美麗而溫柔的漣漪。',
  },
  {
    id: 'poem-jixian-wuya',
    category: 'poem',
    dynasty: 'modern',
    title: '烏鴉',
    source: '紀弦',
    description: '紀弦現代派風格獨具的孤傲自白。',
    content: '在枯枝的最高處，有一隻黑色的烏鴉。牠不喧嘩，也不討好，只是靜靜地看著夕陽沉落，守著屬於自己的天空。',
  },
  {
    id: 'poem-jixian-tuoxiawaitao',
    category: 'poem',
    dynasty: 'modern',
    title: '脫下外套的季節',
    source: '紀弦',
    description: '紀弦描寫春天來臨、萬物甦醒的輕快詩作。',
    content: '春天來了，脫下厚厚的外套，讓陽光親吻每一寸肌膚。微風吹過綠草如茵的大地，整個世界都在輕輕地唱歌。',
  },

  // --- 吳晟 (5 首) ---
  {
    id: 'poem-wucheng-fuhe',
    category: 'poem',
    dynasty: 'modern',
    title: '負荷',
    source: '吳晟',
    description: '吳晟最著名的國民詩篇，入選中學國文教材，深摯描寫父愛與親情。',
    content: '下班之後，便是黃昏了。偶爾也該去看一場電影，聽聽音樂。只是，滿身汗水和疲憊，總催促著我，快快回到你們的身邊。看著你們香甜入睡的臉龐，這是我生命中，最沉重，也是最甜蜜的負荷。',
  },
  {
    id: 'poem-wucheng-nitu',
    category: 'poem',
    dynasty: 'modern',
    title: '泥土',
    source: '吳晟',
    description: '吳晟歌詠台灣農民與土地的質樸深情之作。',
    content: '揮汗耕耘的農人，赤著雙腳踏在溫暖的泥土上。泥土不說話，只是默默孕育著金黃的稻穗，滋養著一代又一代勤奮善良的人民。',
  },
  {
    id: 'poem-wucheng-buhanitanlun',
    category: 'poem',
    dynasty: 'modern',
    title: '我不和你談論',
    source: '吳晟',
    description: '吳晟經典鄉土詩，強調腳踏實地感受土地與自然的真實。',
    content: '我不和你談論詩藝，不和你談論人生大道理。我只想邀你一起，挽起褲管走向田野，去聽聽稻浪翻滾的聲音，去聞聞泥土芬芳的氣息。',
  },
  {
    id: 'poem-wucheng-jieti',
    category: 'poem',
    dynasty: 'modern',
    title: '階梯',
    source: '吳晟',
    description: '吳晟寄寓人生哲思與步步踏實的抒情佳作。',
    content: '一步一步往上爬，不要嫌階梯太長太陡。每上一階，視野就更寬闊一分；只要不停下腳步，終會看見山頂燦爛的朝霞。',
  },
  {
    id: 'poem-wucheng-shaiguchang',
    category: 'poem',
    dynasty: 'modern',
    title: '晒穀場',
    source: '吳晟',
    description: '吳晟筆下的台灣傳統農村記憶與收穫之美。',
    content: '金黃色的稻穀鋪滿了晒穀場，在豔陽下散發著成熟的穀香。阿公推著木耙翻動著穀粒，臉上的皺紋笑成了秋天最美的豐收圖卷。',
  },

  // --- 向陽 (5 首) ---
  {
    id: 'poem-xiangyang-lichang',
    category: 'poem',
    dynasty: 'modern',
    title: '立場',
    source: '向陽',
    description: '向陽十行詩代表作，表達超然包容的視角與人文情懷。',
    content: '你問我立場，沉默地我望著天空的飛鳥。飛鳥翱翔在無垠的天際，沒有界線，也沒有標籤。大地如此寬廣，容得下所有的江河，也容得下所有的夢想。',
  },
  {
    id: 'poem-xiangyang-feng',
    category: 'poem',
    dynasty: 'modern',
    title: '小詩十首·風',
    source: '向陽',
    description: '向陽短詩名篇，以靈動意象捕捉大自然的呼吸。',
    content: '風從山谷走來，輕輕翻動樹梢的綠葉。它沒有形狀，卻讓整個森林有了歌聲；它沒有停留，卻把春天的消息帶給了每一朵花。',
  },
  {
    id: 'poem-xiangyang-yaosheshi',
    category: 'poem',
    dynasty: 'modern',
    title: '咬舌詩',
    source: '向陽',
    description: '向陽探索語言本質與母語情懷的經典詩作。',
    content: '咬著舌頭說話，字字都是心底深處的吶喊。那些被歲月掩埋的鄉音，如同地下湧動的泉水，終將衝破岩層，匯成清脆的歌聲。',
  },
  {
    id: 'poem-xiangyang-qiufengdushu',
    category: 'poem',
    dynasty: 'modern',
    title: '秋風讀書',
    source: '向陽',
    description: '向陽充滿書香氣息與寧靜氛圍的知性詩作。',
    content: '窗外秋風漸起，案頭書頁輕翻。字裡行間有古人的智慧，也有今人的求索。在一杯清茶的香氣裡，心靈找到了最安穩的歸宿。',
  },
  {
    id: 'poem-xiangyang-xiezi',
    category: 'poem',
    dynasty: 'modern',
    title: '寫字',
    source: '向陽',
    description: '向陽描寫筆墨與心境相融的優美詩篇，極適合作為字帖練字。',
    content: '提筆落墨，一橫一豎皆是心靈的印記。字在紙上安靜地呼吸，如同一粒粒播下的種子，在時光的土壤裡靜靜生長。',
  },

  // --- 夏宇 (5 首) ---
  {
    id: 'poem-xiayu-tianmidefuchou',
    category: 'poem',
    dynasty: 'modern',
    title: '甜蜜的復仇',
    source: '夏宇',
    description: '夏宇傳誦極廣的超人氣代表作，前衛而充滿奇想。',
    content: '把你的影子加點鹽，醃起來，風乾。老的時候，下酒。',
  },
  {
    id: 'poem-xiayu-beidong',
    category: 'poem',
    dynasty: 'modern',
    title: '被動',
    source: '夏宇',
    description: '夏宇靈動幽默的現代抒情短詩。',
    content: '如果雨停了，我就出門；如果你笑了，我就高興。整個世界都可以是安靜的，只要你輕輕點一下頭。',
  },
  {
    id: 'poem-xiayu-lianai',
    category: 'poem',
    dynasty: 'modern',
    title: '戀愛的作用',
    source: '夏宇',
    description: '夏宇以奇特視角解構情感的名篇。',
    content: '在所有的街道上走過，看見所有的路燈都亮了。不是因為天黑，而是因為心裡有了一團不能熄滅的光。',
  },
  {
    id: 'poem-xiayu-richang',
    category: 'poem',
    dynasty: 'modern',
    title: '乃平淡的日常驚人之必要',
    source: '夏宇',
    description: '夏宇代表性哲理散文詩，寫日常中的詩意驚喜。',
    content: '在平淡無奇的下午，突然聞到一陣烤麵包的香氣；在漫長無聊的等待裡，忽然看見一隻藍色的蝴蝶飛過窗前。這就是生活的驚喜。',
  },
  {
    id: 'poem-xiayu-tongqing',
    category: 'poem',
    dynasty: 'modern',
    title: '同情耗盡',
    source: '夏宇',
    description: '夏宇冷峻而深刻的情感剖析。',
    content: '時鐘滴答滴答地走著，把多餘的眼淚都風乾。我們不再為昨天嘆息，因為明天的太陽依然會照常升起。',
  },

  // --- 任明信 (5 首) ---
  {
    id: 'poem-renmingxin-mingyun',
    category: 'poem',
    dynasty: 'modern',
    title: '你沒有更好的命運',
    source: '任明信',
    description: '任明信代表作同名詩，字句平實卻直擊人心。',
    content: '你算過嗎，要走多長的路，才能在一個人身邊坐下。要受多少傷，才能學會溫柔地面對這個世界。你沒有更好的命運，這就是最好的安排。',
  },
  {
    id: 'poem-renmingxin-guangtianhuari',
    category: 'poem',
    dynasty: 'modern',
    title: '光天化日',
    source: '任明信',
    description: '任明信廣受年輕讀者喜愛的療癒短詩。',
    content: '陽光穿透樹葉的縫隙，在地上灑下一片斑駁。就算心裡有烏雲，也要記得抬起頭，看一看頭頂那片澄澈的藍天。',
  },
  {
    id: 'poem-renmingxin-bieren',
    category: 'poem',
    dynasty: 'modern',
    title: '別人',
    source: '任明信',
    description: '任明信探討自我與孤獨的深刻小品。',
    content: '我們總是在別人的故事裡流自己的眼淚，又在自己的歲月裡尋找別人的影子。直到某一天，終於學會了與自己好好相處。',
  },
  {
    id: 'poem-renmingxin-riluo',
    category: 'poem',
    dynasty: 'modern',
    title: '日落',
    source: '任明信',
    description: '任明信描繪黃昏美景與告別的短詩。',
    content: '日落不是結束，而是給黑夜一個溫柔的開場。當最後一抹晚霞散去，星光便會接替太陽，照亮回家的路。',
  },
  {
    id: 'poem-renmingxin-xiabeizi',
    category: 'poem',
    dynasty: 'modern',
    title: '下輩子',
    source: '任明信',
    description: '任明信極具感染力的抒情名作。',
    content: '如果還有下輩子，想做一棵長在山谷裡的樹。不為誰停留，也不為誰離開，只是安靜地沐浴陽光與雨露，度過漫長而平靜的一生。',
  },

  // --- 陳繁齊 (5 首) ---
  {
    id: 'poem-chenfanqi-xiayuderen',
    category: 'poem',
    dynasty: 'modern',
    title: '下雨的人',
    source: '陳繁齊',
    description: '陳繁齊暢銷成名作，以雨為喻寫深情陪伴。',
    content: '我只是想被你理解，像一場雨被傘理解那樣。不是為了阻擋，而是為了在同一個屋簷下，靜靜聽完這場雨落下的聲音。',
  },
  {
    id: 'poem-chenfanqi-zuikaojinnide',
    category: 'poem',
    dynasty: 'modern',
    title: '那些最靠近你的',
    source: '陳繁齊',
    description: '陳繁齊細膩溫柔的情感短詩，手寫圈最愛篇章。',
    content: '願你所有的溫柔都有歸處，願你所有的付出都被珍惜。在漫長的歲月裡，願有人陪你立黃昏，有人問你粥可溫。',
  },
  {
    id: 'poem-chenfanqi-gengbaodedifang',
    category: 'poem',
    dynasty: 'modern',
    title: '我們會在更好的地方相遇',
    source: '陳繁齊',
    description: '陳繁齊充滿希望與祝福的溫暖詩作。',
    content: '不要害怕走散，山水總會相逢。只要心中有光，無論走得多遠，我們終將在春暖花開的季節，微笑著再次相遇。',
  },
  {
    id: 'poem-chenfanqi-richang',
    category: 'poem',
    dynasty: 'modern',
    title: '日常',
    source: '陳繁齊',
    description: '陳繁齊記錄生活微光的美麗詩篇。',
    content: '買一束喜歡的花，泡一杯溫熱的茶。把窗戶打開，讓清晨的微風吹進屋裡。平凡的每一天，都值得被認真對待。',
  },
  {
    id: 'poem-chenfanqi-cuiruo',
    category: 'poem',
    dynasty: 'modern',
    title: '脆弱',
    source: '陳繁齊',
    description: '陳繁齊描寫接納真實自我、給予心靈力量的詩篇。',
    content: '允許自己偶爾脆弱，就像天空允許自己下雨一樣。雨過之後，泥土會更加芬芳，草木會更加青翠，而你也會變得更加堅強。',
  },

  // --- 鯨向海 (5 首) ---
  {
    id: 'poem-jingxianghai-tongjifan',
    category: 'poem',
    dynasty: 'modern',
    title: '通緝犯',
    source: '鯨向海',
    description: '鯨向海人氣極高的代表作，充滿青春的叛逆與浪漫。',
    content: '被你的眼神通緝了一整個夏天，我卻心甘情願地自首。在愛情的法庭上，我願意被判終身監禁在你的心裡。',
  },
  {
    id: 'poem-jingxianghai-daweizhenjing',
    category: 'poem',
    dynasty: 'modern',
    title: '大為震驚',
    source: '鯨向海',
    description: '鯨向海幽默奇趣的現代詩風。',
    content: '當我看見海浪一次又一次親吻沙灘，我看見雲朵在天空中變換各種形狀，我大為震驚：原來這世界如此美麗，只因為你在我身旁。',
  },
  {
    id: 'poem-jingxianghai-jiangai',
    category: 'poem',
    dynasty: 'modern',
    title: '將愛',
    source: '鯨向海',
    description: '鯨向海熱烈奔放的抒情短詩。',
    content: '將愛寫在風裡，讓風吹遍整座城市；將愛寫在海裡，讓浪潮湧向天涯海角。只要你轉身，就能看見我守候的身影。',
  },
  {
    id: 'poem-jingxianghai-jingshenbingyuan',
    category: 'poem',
    dynasty: 'modern',
    title: '精神病院的黃昏',
    source: '鯨向海',
    description: '鯨向海以醫師詩人視角觀察生命與人性的名作。',
    content: '黃昏的金光灑在純白色的病房裡，每個人都在安靜地看著窗外的落日。世界或許有許多瘋狂，但在此刻，我們都找到了平靜。',
  },
  {
    id: 'poem-jingxianghai-qingchun',
    category: 'poem',
    dynasty: 'modern',
    title: '青春',
    source: '鯨向海',
    description: '鯨向海致敬青春與歲月的深情之歌。',
    content: '青春是一場奔赴大海的旅程，我們在烈日下奔跑，在星空下唱歌。即使受了傷，那也是歲月賜予我們最驕傲的勳章。',
  },
]